<style>
.SessionlistMultitracker.session-list-wrapper {
  margin-left: 0;
}
.session-head-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.session-head-wrap h1.page-head {
  margin-bottom: 0;
}
.session-head-tab-wrapper button.common-tab-button {
  width: 120px;
  padding: 6px 0;
  font-size: 14px;
  font-weight: 600;
  background: #fff;
  border: 1px solid #000;
}
.session-head-tab-wrapper button.common-tab-button.border-left-radius {
  border-radius: 5px 0 0 5px;
  border-right: none;
}
.session-head-tab-wrapper button.common-tab-button.border-right-radius {
  border-radius: 0px 5px 5px 0px;
  border-left: none;
}
.session-head-tab-wrapper button.common-tab-button.active-btn {
  background: #000;
  color: #fff;
}
.session-link {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.session-type-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px;
  width: 40px;
  overflow: hidden;
}
.session-type-icon img {
  max-width: 100%;
  max-height: 100%;
}
.session-details .session-live-des #dvBroadcast li label img {
  -webkit-filter: none;
  filter: none;
}

.session-details .session-live-des #dvBroadcast a.upcoming-status {
  background: #ddd;
}

/****session****/
.SessionlistMultitracker .four-track .track-box {
  width: 24%;
  float: left;
}
.flex-wrap-four {
  flex-wrap: wrap;
}
.flex-wrap-four .row.main-divider.main-divider-continue {
  margin-top: 60px !important;
}
.main-divider-continue {
  position: relative !important;
}

.two-session #dvBroadcast {
  justify-content: flex-end;
}
.two-session .icon-bookmark1.bmark-pupupbtn {
  margin: 0 !important;
}

.flex-wrap-four .row.main-divider.main-divider-continue .track-headding {
  padding-left: 0;
}
.flex-wrap-four .row.main-divider.main-divider-continue .white-b-wrapper {
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 1px 6px 0 rgb(28 28 28 / 10%);
}
.flex-wrap-four .row.main-divider.main-divider-continue .white-b-wrapper:hover {
  box-shadow: 0 1px 6px 0 rgb(0 0 0 / 50%);
}

.track-box-continue {
  position: relative;
  width: 100%;
  background-color: #d7d7ea;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.track-box.track-box-continue:empty {
  background: transparent !important;
  background-color: transparent !important;
}
.visibility-hidden {
  visibility: hidden;
}
.retry-modal {
  text-align: center;
}
.retry-modal .button-no {
  padding: 10px 30px;
  border-radius: 5px;
  color: #1e1f26;
  background: #eee;
  font-weight: 600;
  font-size: 14px;
  display: inline-block;
  margin-top: 20px;
  margin-right: 10px;
}
.retry-modal .button-yes {
  padding: 10px 30px;
  border-radius: 5px;
  color: #fff;
  background: #0b8a20;
  font-weight: 600;
  font-size: 14px;
  display: inline-block;
  margin-top: 20px;
}
.mobile-session-dropdown {
  display: none;
}
.new-btn-design {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  margin-left: 15px;
  padding: 8px 12px 8px 0;
  min-width: auto;
  background: #19a883;
  border-radius: 5px;
}
.new-btn-design img {
  border-right: 1px solid rgba(255, 255, 255, 0.4);
  padding: 0 12px;
}
.new-btn-design span {
  color: #fff;
  font-weight: 600 !important;
  font-size: 14px !important;
  margin-left: 10px !important;
}
.new-btn-design-disabled {
  opacity: 1;
  background: #d4d6d7 !important;
}
.three-session #dvBroadcast {
  justify-content: flex-start;
}
.three-session .new-btn-design {
  margin: 0 !important;
}
.col-12.pl-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.v-application p {
  margin: unset;
}
.v-application ol,
.v-application ul {
  padding: 0 !important;
}
.on-demand-session-option {
  position: relative;
}
.on-demand-session-option p {
  margin: 0 0 0 2px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  padding: 0 4px;
}
.on-demand-session-option p span {
  height: 6px;
  width: 6px;
  background: #333;
  display: inline-block;
  border-radius: 50%;
  cursor: pointer;
  margin: 2px;
}
.on-demand-dropdown {
  position: absolute;
  right: 4px;
  bottom: 100%;
  min-width: 169px;
  background: #fff;
  min-height: 41px;
  padding: 0 15px;
  border-radius: 6px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  z-index: 999999;
  margin-bottom: 15px;
}
/*.on-demand-dropdown:before {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid transparent;
    border-bottom: 10px solid #fff;
    bottom: 100%;
    left: auto;
    right: 11px;
    box-shadow: 0 0 5px rgb(0 0 0 / 20%); 
     overflow: hidden; 
}*/
.on-demand-dropdown ul {
  margin: 0;
  padding: 0;
}
.on-demand-dropdown ul li {
  list-style: none;
  font-size: 0.875rem;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 0;
  font-weight: 400;
  cursor: pointer;
}
.on-demand-dropdown ul li:last-child {
  border-bottom: none;
}
/*------------------------------------------*/
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .tooltip.show {
    display: none;
  }
  .new-btn-design {
    min-width: auto;
  }
  .three-session .new-btn-design {
    width: auto;
  }
  .two-session .new-btn-design {
    width: auto;
  }
}

.session-time-zone {
  text-align: left;
  color: #8b8b8b;
}
.session-time-zone:before {
  content: "\f0ac";
  font: normal normal normal 16px/1 FontAwesome;
  height: 15px;
  width: 15px;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  color: #919297;
  padding-right: 5px;
}
@media only screen and (max-width: 767px) {
  .new-btn-design {
    min-width: auto;
  }
  .three-session .new-btn-design {
    width: auto;
  }
  .two-session .new-btn-design {
    width: auto;
  }

  .mobile-session-dropdown {
    display: block;
  }
  .mobile-session-dropdown select {
    width: 100%;
    height: 40px;
    border: 1px solid #dfdfdf;
    padding: 0 20px 0 15px;
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    -moz-appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    background: #fff url(../assets/Images/icons/down-arrow-black.svg) no-repeat
      scroll right 12px center / 20px;
    margin-bottom: 15px;
  }
  .mobile-session-dropdown select:focus {
    outline: none !important;
  }
  /* .web-session-tab {
    display: none;
  } */
  .nav-tabs .mob-none.session-nav-tab {
    display: none;
  }
  .SessionlistMultitracker #dvBroadcast a.schedule-speaker {
    margin-right: 0 !important;
    display: none;
  }
  #dvBroadcast {
    justify-content: center;
  }
  .plus-circle {
    display: none;
  }

  .new-btn-design img {
    height: 21px;
    width: 48px;
  }
  .session-head-wrap {
    flex-direction: column;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape) {
  .plus-circle {
    display: none;
  }
  .SessionlistMultitracker #dvBroadcast a.schedule-speaker {
    margin-right: 0 !important;
    display: none;
  }
  .tooltip.show {
    display: none;
  }
  .new-btn-design img {
    height: 21px;
    width: 48px;
  }
}
</style>

<template>
  <div @click="onClickHandler">
    <div id="divContainer" class="page-effect" v-on:click="exitmenu">
      <!-- <TopMenu /> -->
      <section
        id="sectionId"
        class="session-list-wrapper d-flex body-content SessionlistMultitracker"
      >
        <div class="container-fluid">
          <div class="row session-head-wrap">
            <v-col md="6" cols="12">
              <h1 id="headerText" class="page-head text-uppercase mt-3"></h1>
              <!-- <v-autocomplete
                v-if="$route.path.includes('mainlobby')"
                dense
                outlined
                v-model="speakerEvent"
                :items="$store.state.MappedEvent"
                prepend-inner-icon="search"
                return-object
                hide-details
                label="Select Event"
                item-text="EventFullName"
              ></v-autocomplete> -->
              <!-- <h1 v-else id="headerText" class="page-head text-uppercase"></h1> -->
              <h6 class="session-time-zone mt-1" style="color: #8b8b8b">
                {{ localTimeZone }}
              </h6>
            </v-col>

            <div
              v-show="
                AgendaFilterOption == 2 &&
                selectedAgendaType >= 0 &&
                sessionSettingsLoaded &&
                mySessionsLoaded &&
                mySessions.length > 0
              "
              class="session-head-tab-wrapper d-none1"
            >
              <button
                :class="
                  selectedAgendaType == 1
                    ? 'common-tab-button border-left-radius active-btn'
                    : 'common-tab-button border-left-radius'
                "
                @click="onAgendaTypeChanged(1)"
              >
                {{ $t("sessions.myagenda") }}
              </button>
              <button
                :class="
                  selectedAgendaType == 0
                    ? 'common-tab-button border-right-radius active-btn'
                    : 'common-tab-button border-right-radius'
                "
                @click="onAgendaTypeChanged(0)"
              >
                {{ $t("sessions.fullagenda") }}
              </button>
            </div>
          </div>
          <div class="row session-tab-wrapper" style="getWidth()">
            <!--date tab -->

            <div class="" style="width: 100%">
              <div class="col-md-12 py-0">
                <div class="mobile-session-dropdown">
                  <select
                    v-model="selectedDateValue"
                    @change="mobileDropdownChange()"
                  >
                    <option
                      v-for="dateTab in dateTabs"
                      v-bind:key="dateTab.DateTabId"
                      :value="dateTab.DateTabId"
                    >
                      {{ dateTab.DateTabLabel }}
                    </option>
                  </select>
                </div>

                <ul class="nav nav-tabs session-nav-tab mob-none" role="tablist">
                  <li
                    v-for="(dateTab, index) in dateTabs"
                    :key="dateTab.DateTabId"
                    class="nav-item"
                  >
                    <a
                      v-if="index == 0"
                      :id="'a_' + dateTab.DateTabId"
                      @click="
                        onTabChange(
                          dateTab.DateTabId,
                          dateTab.StartTime,
                          dateTab.EndTime
                        )
                      "
                      v-bind:class="'nav-link ' + dateTab.CurrentClass"
                      data-tag="sessionDate"
                    >
                      {{ dateTab.DateTabLabel }}
                      <!---{{ dateTab.StartTime }}:{{dateTab.EndTime}}-->
                    </a>
                    <a
                      v-else
                      :id="'a_' + dateTab.DateTabId"
                      @click="
                        onTabChange(
                          dateTab.DateTabId,
                          dateTab.StartTime,
                          dateTab.EndTime
                        )
                      "
                      v-bind:class="'nav-link ' + dateTab.CurrentClass"
                      data-tag="sessionDate"
                      >{{ dateTab.DateTabLabel }}
                      <!---{{ dateTab.StartTime }}:{{dateTab.EndTime}}-->
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!--date tab ends -->

            <br />
            <div
              v-show="
                sessionSettingsLoaded && sessionsLoaded && mySessionsLoaded
              "
              class="tab-content col-md-12"
              id="dvMainTabContent"
            >
              <div
                v-for="sessionContent in selectedTabSessions"
                v-bind:key="sessionContent.DateTabId"
                v-bind:class="'tab-pane1 ' + sessionContent.CurrentClass"
              >
                <div
                  v-for="sessionRow in sessionContent.SessionRowList"
                  :key="sessionRow.SessionCollection[0].SessionId"
                >
                  <!--first row ends -->
                  <div v-bind:class="'track-headding ' + sessionRow.TrackClass">
                    <div class="row d-md-flex justify-content-between m-0">
                      <div
                        v-for="(
                          singleTrack, index
                        ) in sessionRow.TrackCollection"
                        v-bind:key="singleTrack.TrackName"
                        :class="index < 3 ? 'track-box' : 'track-box d-none'"
                        data-toggle="tooltip"
                        data-placement="top"
                        v-bind:data-original-title="singleTrack.TrackName"
                        v-html="singleTrack.TrackName"
                        :style="
                          'background-color:' + trackColor(singleTrack.TrackId)
                        "
                      ></div>
                    </div>
                  </div>
                  <!--track ends -->
                  <div
                    v-if="sessionRow.RowSessionCount == 1"
                    class="white-box-wrapper one-session"
                  >
                    <div class="time-location">
                      <ul>
                        <li>
                          <span>
                            {{ sessionRow.StartTimeLabel }}
                            <br />
                            {{ sessionRow.EndTimeLabel }}
                          </span>
                        </li>
                        <li style="display: none">
                          <span></span>
                        </li>
                      </ul>
                    </div>
                    <div
                      class="row main-divider"
                      :id="
                        'session_wrap_' +
                        sessionRow.SessionCollection[0].SessionId
                      "
                    >
                      <div class="col-md-8">
                        <div class="col-12 pl-0">
                          <div class="session-status">
                            <p>
                              <span
                                v-bind:class="
                                  sessionRow.SessionCollection[0].StatusClass
                                "
                              ></span>
                              {{
                                sessionRow.SessionCollection[0]
                                  .StatusDisplayText
                              }}
                            </p>
                          </div>
                        </div>
                        <div
                          data-toggle="modal"
                          v-bind:data-target="
                            '#session' +
                            sessionRow.SessionCollection[0].SessionId
                          "
                          data-tag="sessionDetails"
                          class="left-area-hld"
                        >
                          <h2
                            data-toggle="tooltip"
                            data-placement="left"
                            v-bind:data-original-title="
                              sessionRow.SessionCollection[0].Name
                            "
                          >
                            {{ sessionRow.SessionCollection[0].Name }}
                            <!---{{sessionRow.SessionCollection[0].StartTime}}:{{ sessionRow.SessionCollection[0].EndTime }}-->
                          </h2>
                          <p>
                            {{
                              sessionRow.SessionCollection[0].DescriptionShort
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="col-md-4 pl-0">
                        <div class="right-area-hld">
                          <a id="anchSessionName0"></a>
                          <div id="dvBroadcast" class="dvBroadcast161369">
                            <a
                              v-for="speaker in sessionRow.SessionCollection[0]
                                .MappedSpeakers"
                              v-bind:key="speaker.AttendeeId"
                              class="schedule-speaker w-inline-block"
                              data-toggle="modal"
                              v-bind:data-target="
                                '#speaker' + speaker.AttendeeId
                              "
                              data-tag="sessionSpeakerDetails"
                              v-show="!speaker.HideInList"
                            >
                              <img
                                v-if="speaker.ProfilePictureURL != ''"
                                v-bind:src="
                                  getCDNUrl(speaker.ProfilePictureURL)
                                "
                                v-bind:alt="speaker.NameInitial"
                                class="schedule-speaker-image"
                                data-toggle="tooltip"
                                data-html="true"
                                v-bind:title="
                                  '<strong>' +
                                  speaker.Name +
                                  '</strong><br />' +
                                  speaker.Company
                                "
                                v-bind:data-original-title="
                                  speaker.Name + ', ' + speaker.Company
                                "
                              />
                              <span
                                v-else-if="speaker.NameInitial != ''"
                                class="speaker-name-initial"
                                data-toggle="tooltip"
                                data-html="true"
                                v-bind:title="
                                  '<strong>' +
                                  speaker.Name +
                                  '</strong><br />' +
                                  speaker.Company
                                "
                                v-bind:data-original-title="
                                  speaker.Name + ', ' + speaker.Company
                                "
                                >{{ speaker.NameInitial }}</span
                              >
                              <img
                                v-else
                                v-bind:src="avatarImageUrl"
                                v-bind:alt="speaker.NameInitial"
                                class="schedule-speaker-image"
                                data-toggle="tooltip"
                                data-html="true"
                                v-bind:title="
                                  '<strong>' +
                                  speaker.Name +
                                  '</strong><br />' +
                                  speaker.Company
                                "
                                v-bind:data-original-title="
                                  speaker.Name + ', ' + speaker.Company
                                "
                              />
                            </a>

                            <span
                              data-toggle="modal"
                              v-bind:data-target="
                                '#session' +
                                sessionRow.SessionCollection[0].SessionId
                              "
                              v-if="sessionRow.SessionCollection[0].ShowPlush"
                              data-tag="sessionSpeakerplus"
                              class="plus-circle"
                              >+{{
                                sessionRow.SessionCollection[0].Plushcount
                              }}</span
                            >
                            <a id="anchSessionName0"></a>
                            <a
                              v-bind:id="
                                'sn_' +
                                sessionRow.SessionCollection[0].SessionId
                              "
                              v-if="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeID ==
                                  GlobalKeysData.OnDemandTypeID &&
                                sessionRow.SessionCollection[0].IsLive
                              "
                              href="javascript:void(0)"
                              v-on:click="
                                ShowBroadCastPg(
                                  sessionRow.SessionCollection[0].SessionId,
                                  GlobalKeysData.IsVideoInNewTab,
                                  'video',
                                  eventId,
                                  GlobalKeysData.IsOpenInternalPlayer
                                )
                              "
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                sessionRow.SessionCollection[0].LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              data-tag="sessionPreVideo"
                              data-original-title="On-Demand"
                            >
                              <img src="../assets/Images/on-demand-white.svg" />
                              <span data-tag="On-Demand">WATCH NOW</span>
                            </a>
                            <a
                              v-if="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeID ==
                                  GlobalKeysData.OnDemandTypeID &&
                                !sessionRow.SessionCollection[0].IsLive
                              "
                              href="javascript:void(0)"
                              id="bk_161353"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                sessionRow.SessionCollection[0].LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              data-tag="sessionPreVideo"
                              data-original-title="On-Demand"
                            >
                              <img src="../assets/Images/on-demand-white.svg" />
                              <span data-tag="On-Demand">WATCH NOW</span>
                            </a>
                            &nbsp;
                            <a
                              v-if="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeID ===
                                  GlobalKeysData.LiveStreamTypeID &&
                                sessionRow.SessionCollection[0].IsLive
                              "
                              id="linkRoundTableTopic"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                sessionRow.SessionCollection[0].LinkClass
                              "
                              v-on:click="
                                ShowBroadCastPg(
                                  sessionRow.SessionCollection[0].SessionId,
                                  GlobalKeysData.IsVideoInNewTab,
                                  'video',
                                  eventId,
                                  GlobalKeysData.IsOpenInternalPlayer
                                )
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              v-bind:title="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeName
                              "
                              v-bind:data-original-title="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeName
                              "
                              data-tag="sessionLive"
                            >
                              <img
                                src="../assets/Images/live-stream-white.svg"
                              />
                              <span>WATCH NOW</span>
                            </a>
                            <a
                              v-if="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeID ===
                                  GlobalKeysData.LiveStreamTypeID &&
                                !sessionRow.SessionCollection[0].IsLive
                              "
                              id="linkRoundTableTopic"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                sessionRow.SessionCollection[0].LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              v-bind:title="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeName
                              "
                              v-bind:data-original-title="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeName
                              "
                              data-tag="sessionLive"
                            >
                              <img
                                src="../assets/Images/live-stream-white.svg"
                              />
                              <span>WATCH NOW</span> </a
                            >&nbsp;
                            <!--//+sessionRow.SessionCollection[0].SessionTypeDetails.RoundTableTopic.TopicId-->
                            <!-- <a
                              v-bind:href="
                                '/roundtable/' +
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.RoundTableTopic.TopicId
                              "
                              v-else-if="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeID ===
                                  GlobalKeysData.RoundTableTypeID &&
                                sessionRow.SessionCollection[0].IsLive
                              "
                              id="linkRoundTableTopic"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn ' +
                                sessionRow.SessionCollection[0].LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              v-bind:title="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeName
                              "
                              v-bind:data-original-title="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeName
                              "
                              data-tag="sessionRoundTable"
                            >
                              <img src="../assets/Images/round-table.svg" />
                              <span>{{
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeName
                              }}</span> </a
                            > -->
                            <a
                              href="javascript:void(0)"
                              v-on:click="
                                goForlivestage(
                                  sessionRow.SessionCollection[0].SessionId,
                                  sessionRow.SessionCollection[0]
                                    .SessionTypeDetails.RoundTableTopic.TopicId
                                )
                              "
                              v-else-if="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeID ===
                                  GlobalKeysData.RoundTableTypeID &&
                                sessionRow.SessionCollection[0].IsLive
                              "
                              id="linkRoundTableTopic"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                sessionRow.SessionCollection[0].LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              v-bind:title="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeName
                              "
                              v-bind:data-original-title="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeName
                              "
                              data-tag="sessionRoundTable"
                            >
                              <img
                                src="../assets/Images/round-table-white.svg"
                              />
                              <span>JOIN NOW</span>
                            </a>

                            <a
                              href="javascript:void(0)"
                              v-else-if="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeID ===
                                  GlobalKeysData.RoundTableTypeID &&
                                !sessionRow.SessionCollection[0].IsLive
                              "
                              id="linkRoundTableTopic"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                sessionRow.SessionCollection[0].LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              v-bind:title="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeName
                              "
                              v-bind:data-original-title="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeName
                              "
                              data-tag="sessionRoundTable"
                            >
                              <img
                                src="../assets/Images/round-table-white.svg"
                              />
                              <span>JOIN NOW</span> </a
                            >&nbsp;
                            <a
                              v-else-if="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeID ==
                                  GlobalKeysData.LivePanelTypeID &&
                                sessionRow.SessionCollection[0].IsLive
                              "
                              href="javascript:void(0)"
                              v-on:click="
                                goForGreenRoom(
                                  GlobalKeysData.videoParamsEncryptURL,
                                  GlobalKeysData.BroadcastStartURL,
                                  GlobalKeysData.BroadcastViewURL,
                                  GlobalKeysData.IsBroadcastInNewTab,
                                  sessionRow.SessionCollection[0].SessionId,
                                  GlobalKeysData.ChannelPrefix,
                                  GlobalKeysData.BroadcastID,
                                  GlobalKeysData.BroadcastCertificate,
                                  GlobalKeysData.BroadcastSpeakerApiUrl,
                                  GlobalKeysData.BroadcastAttendeeApiUrl,
                                  GlobalKeysData.BroadcastvalidityHours,
                                  userid,
                                  eventId,
                                  'startbroadcast',
                                  sessionRow.SessionCollection[0].Name,
                                  sessionRow.SessionCollection[0]
                                    .broadcastUrlForSession,
                                  clientID,
                                  sessionRow.SessionCollection[0]
                                    .IamInThesession,
                                  GlobalKeysData.IsOpenInternalPlayer,
                                  sessionRow.SessionCollection[0]
                                    .StreamingClient,
                                  sessionRow.SessionCollection[0].MappedHosts,
                                  sessionRow.SessionCollection[0].AllSpeakers,
                                  sessionRow.SessionCollection[0].Zoom_Detail,
                                  sessionRow.SessionCollection[0].IsZoomRTMP,
                                  sessionRow.SessionCollection[0]
                                    .ZoomRTMPMUX_detail
                                )
                              "
                              id="start_161385"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                sessionRow.SessionCollection[0].LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              v-bind:title="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeName
                              "
                              v-bind:data-original-title="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeName
                              "
                              data-tag="joinSession"
                            >
                              <img
                                src="../assets/Images/live-panel-white.svg"
                              />
                              <span>{{
                                sessionRow.SessionCollection[0]
                                  .HasBackStageAccess
                                  ? "ENTER BACKSTAGE"
                                  : "JOIN NOW"
                              }}</span>
                            </a>
                            <a
                              v-else-if="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeID ==
                                  GlobalKeysData.LivePanelTypeID &&
                                !sessionRow.SessionCollection[0].IsLive
                              "
                              href="javascript:void(0)"
                              id="start_161385"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                sessionRow.SessionCollection[0].LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              v-bind:title="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeName
                              "
                              v-bind:data-original-title="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeName
                              "
                            >
                              <img
                                src="../assets/Images/live-panel-white.svg"
                              />
                              <span>JOIN NOW</span> </a
                            >&nbsp;
                            <a
                              v-else-if="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeID ==
                                  GlobalKeysData.InPersonTypeID &&
                                sessionRow.SessionCollection[0].IsLive
                              "
                              href="javascript:void(0)"
                              v-on:click="
                                goForGreenRoom(
                                  GlobalKeysData.videoParamsEncryptURL,
                                  GlobalKeysData.BroadcastStartURL,
                                  GlobalKeysData.BroadcastViewURL,
                                  GlobalKeysData.IsBroadcastInNewTab,
                                  sessionRow.SessionCollection[0].SessionId,
                                  GlobalKeysData.ChannelPrefix,
                                  GlobalKeysData.BroadcastID,
                                  GlobalKeysData.BroadcastCertificate,
                                  GlobalKeysData.BroadcastSpeakerApiUrl,
                                  GlobalKeysData.BroadcastAttendeeApiUrl,
                                  GlobalKeysData.BroadcastvalidityHours,
                                  userid,
                                  eventId,
                                  'startbroadcast',
                                  sessionRow.SessionCollection[0].Name,
                                  sessionRow.SessionCollection[0]
                                    .broadcastUrlForSession,
                                  clientID,
                                  sessionRow.SessionCollection[0]
                                    .IamInThesession,
                                  GlobalKeysData.IsOpenInternalPlayer,
                                  sessionRow.SessionCollection[0]
                                    .StreamingClient,
                                  sessionRow.SessionCollection[0].MappedHosts,
                                  sessionRow.SessionCollection[0].AllSpeakers,
                                  sessionRow.SessionCollection[0].Zoom_Detail,
                                  sessionRow.SessionCollection[0].IsZoomRTMP,
                                  sessionRow.SessionCollection[0]
                                    .ZoomRTMPMUX_detail,
                                  sessionRow.SessionCollection[0].InPersonURL
                                )
                              "
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn new-btn-design session-link ' +
                                sessionRow.SessionCollection[0].LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              v-bind:title="
                                sessionRow.SessionCollection[0].InPersonLabel
                              "
                              v-bind:data-original-title="
                                sessionRow.SessionCollection[0].InPersonLabel
                              "
                              data-tag="joinSession"
                            >
                              <!--<img src="../assets/Images/in-person.svg" />-->
                              <span class="session-type-icon"
                                ><img
                                  v-bind:src="
                                    sessionRow.SessionCollection[0].InPersonIcon
                                  "
                              /></span>
                              <span>{{
                                sessionRow.SessionCollection[0].InPersonLabel
                              }}</span>
                            </a>
                            <a
                              v-else-if="
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeID ==
                                  GlobalKeysData.InPersonTypeID &&
                                !sessionRow.SessionCollection[0].IsLive
                              "
                              href="javascript:void(0)"
                              id="start_161385"
                              v-bind:class="
                                'icon-bookmark1 bmark-pupupbtn new-btn-design session-link ' +
                                sessionRow.SessionCollection[0].LinkClass
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              v-bind:title="
                                sessionRow.SessionCollection[0].InPersonLabel
                              "
                              v-bind:data-original-title="
                                sessionRow.SessionCollection[0].InPersonLabel
                              "
                            >
                              <span class="session-type-icon"
                                ><img
                                  v-bind:src="
                                    sessionRow.SessionCollection[0].InPersonIcon
                                  "
                              /></span>
                              <span>{{
                                sessionRow.SessionCollection[0].InPersonLabel
                              }}</span>
                            </a>
                            <!--<div
                              v-if="
                                IsZoomRTMPOptionsEnabled &&
                                sessionRow.SessionCollection[0]
                                  .SessionTypeDetails.TypeID ==
                                  GlobalKeysData.LivePanelTypeID &&
                                sessionRow.SessionCollection[0].IsLive &&
                                sessionRow.SessionCollection[0].IsZoomRTMP &&
                                sessionRow.SessionCollection[0]
                                  .ZoomMeetingStarted &&
                                (sessionRow.SessionCollection[0].IsHost ||
                                  (sessionRow.SessionCollection[0].IsSpeaker &&
                                    sessionRow.SessionCollection[0]
                                      .ZoomRTMPStarted))
                              "
                              class="on-demand-session-option"
                            >
                              <p
                                @click="
                                  toggleMoreSessionActions(
                                    sessionRow.SessionCollection[0].SessionId,
                                    $event
                                  )
                                "
                              >
                                <span></span>
                                <span></span>
                                <span></span>
                              </p>
                              <div class="on-demand-dropdown d-none">
                                <ul>
                                  <li
                                    v-if="
                                      sessionRow.SessionCollection[0].IsHost &&
                                      sessionRow.SessionCollection[0]
                                        .ZoomMeetingStarted &&
                                      !sessionRow.SessionCollection[0]
                                        .ZoomRTMPStarted
                                    "
                                    @click="
                                      StartRTMPStreaming(
                                        sessionRow.SessionCollection[0]
                                          .SessionId,
                                        $event
                                      )
                                    "
                                  >
                                    Start RTMP Streaming
                                  </li>
                                  <li
                                    v-if="
                                      sessionRow.SessionCollection[0].IsHost &&
                                      sessionRow.SessionCollection[0]
                                        .ZoomRTMPStarted
                                    "
                                    @click="
                                      StopRTMPStreaming(
                                        sessionRow.SessionCollection[0]
                                          .SessionId,
                                        $event
                                      )
                                    "
                                  >
                                    Stop RTMP Streaming
                                  </li>
                                  <li
                                    v-if="
                                      (sessionRow.SessionCollection[0].IsHost ||
                                        sessionRow.SessionCollection[0]
                                          .IsSpeaker) &&
                                      sessionRow.SessionCollection[0]
                                        .ZoomRTMPStarted
                                    "
                                    @click="
                                      goForGreenRoom(
                                        GlobalKeysData.videoParamsEncryptURL,
                                        GlobalKeysData.BroadcastStartURL,
                                        GlobalKeysData.BroadcastViewURL,
                                        GlobalKeysData.IsBroadcastInNewTab,
                                        sessionRow.SessionCollection[0]
                                          .SessionId,
                                        GlobalKeysData.ChannelPrefix,
                                        GlobalKeysData.BroadcastID,
                                        GlobalKeysData.BroadcastCertificate,
                                        GlobalKeysData.BroadcastSpeakerApiUrl,
                                        GlobalKeysData.BroadcastAttendeeApiUrl,
                                        GlobalKeysData.BroadcastvalidityHours,
                                        userid,
                                        eventId,
                                        'startbroadcast',
                                        sessionRow.SessionCollection[0].Name,
                                        sessionRow.SessionCollection[0]
                                          .broadcastUrlForSession,
                                        clientID,
                                        sessionRow.SessionCollection[0]
                                          .IamInThesession,
                                        GlobalKeysData.IsOpenInternalPlayer,
                                        sessionRow.SessionCollection[0]
                                          .StreamingClient,
                                        sessionRow.SessionCollection[0]
                                          .MappedHosts,
                                        sessionRow.SessionCollection[0]
                                          .AllSpeakers,
                                        sessionRow.SessionCollection[0]
                                          .Zoom_Detail,
                                        sessionRow.SessionCollection[0]
                                          .IsZoomRTMP,
                                        sessionRow.SessionCollection[0]
                                          .ZoomRTMPMUX_detail,
                                        sessionRow.SessionCollection[0]
                                          .InPersonURL,
                                        true
                                      )
                                    "
                                  >
                                    Interact with Audience
                                  </li>
                                </ul>
                              </div>
                            </div>-->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--else part start -->

                  <div v-else>
                    <!--first row ends -->
                    <!-- <div v-bind:class="'track-headding '+sessionRow.TrackClass">
                      <div class="row d-md-flex justify-content-between m-0">
                        <div
                          v-for="singleTrack in sessionRow.TrackCollection"
                          v-bind:key="singleTrack.TrackName"
                          class="track-box"
                        >{{singleTrack.TrackName}}</div>
                      </div>
                    </div>-->
                    <!--track ends -->
                    <div
                      v-bind:class="
                        'white-box-wrapper ' + sessionRow.SessionClass
                      "
                    >
                      <div class="time-location">
                        <ul>
                          <li>
                            <span>
                              {{ sessionRow.StartTimeLabel }}
                              <br />
                              {{ sessionRow.EndTimeLabel }}
                            </span>
                          </li>
                          <li style="display: none">
                            <span></span>
                          </li>
                        </ul>
                      </div>

                      <!-- <div> -->
                      <div
                        v-for="(
                          singleSession, index
                        ) in sessionRow.SessionCollection"
                        v-bind:key="singleSession.SessionId"
                        :style="
                          index < 3
                            ? ''
                            : $vuetify.breakpoint.mobile
                            ? ''
                            : 'margin-top: 60px;postition:relative !important'
                        "
                        :class="
                          index < 3
                            ? rowClassCss(index)
                            : 'main-divider-continue mr-2 main-divider  py-0'
                        "
                        :id="
                          'session_wrap_' +
                          sessionRow.SessionCollection[index].SessionId
                        "
                      >
                        <div
                          v-if="singleSession.Track.TrackName && index > 2"
                          class="track-box track-box-continue"
                          data-toggle="tooltip"
                          data-placement="top"
                          v-bind:data-original-title="
                            singleSession.Track.TrackName
                          "
                          :style="
                            'background-color:' +
                            trackColor(singleSession.Track.TrackID)
                          "
                          style="position: absolute; top: -50px"
                        >
                          {{ singleSession.Track.TrackName }}
                        </div>
                        <!--<div v-if="singleSession.SessionId==''"></div>-->
                        <div
                          :class="
                            sessionRow.SessionClass.includes('three-session')
                              ? 'col-lg-12 col-md-12 col-12 py-0'
                              : sessionRow.SessionClass.includes('two-session')
                              ? ipadScreen == false
                                ? 'col-lg-8 col-md-8 py-0 col-12'
                                : 'col-lg-12 col-md-8 py-0 col-12'
                              : 'col-md-8 py-0'
                          "
                        >
                          <div class="col-12 pl-0">
                            <div class="session-status">
                              <p>
                                <span
                                  v-bind:class="singleSession.StatusClass"
                                ></span>
                                {{ singleSession.StatusDisplayText }}
                              </p>
                            </div>
                          </div>
                          <div
                            data-toggle="modal"
                            v-bind:data-target="
                              '#session' + singleSession.SessionId
                            "
                            data-tag="singleSessionDetails"
                            class="left-area-hld"
                          >
                            <h2
                              data-toggle="tooltip"
                              data-placement="top"
                              v-bind:data-original-title="
                                sessionRow.SessionCollection[index].Name
                              "
                            >
                              {{ sessionRow.SessionCollection[index].Name }}
                              <!---{{sessionRow.SessionCollection[index].StartTime}}:{{sessionRow.SessionCollection[index].EndTime}}-->
                            </h2>
                            <p></p>
                          </div>
                        </div>
                        <div
                          :class="
                            sessionRow.SessionClass.includes('three-session')
                              ? 'col-lg-8 col-md-12 col-12 py-0'
                              : sessionRow.SessionClass.includes('two-session')
                              ? ipadScreen == false
                                ? 'col-lg-4 col-md-4 col-12'
                                : 'col-lg-8 col-md-12 col-12'
                              : 'col-md-4 pl-0'
                          "
                        >
                          <div class="right-area-hld">
                            <a id="anchSessionName0"></a>
                            <div id="dvBroadcast" class="dvBroadcast161353">
                              <a id="anchSessionName0"></a>
                              <a
                                v-if="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeID ==
                                    GlobalKeysData.OnDemandTypeID &&
                                  singleSession.IsLive
                                "
                                href="javascript:void(0)"
                                v-on:click="
                                  ShowBroadCastPg(
                                    singleSession.SessionId,
                                    GlobalKeysData.IsVideoInNewTab,
                                    'video',
                                    eventId,
                                    GlobalKeysData.IsOpenInternalPlayer
                                  )
                                "
                                id="bk_161353"
                                v-bind:class="
                                  'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                  singleSession.LinkClass
                                "
                                data-toggle="tooltip"
                                data-placement="top"
                                v-bind:title="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeName
                                "
                                v-bind:data-original-title="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeName
                                "
                                data-tag="On-Demand"
                              >
                                <img
                                  data-tag="On-Demand"
                                  src="../assets/Images/on-demand-white.svg"
                                />
                                <span data-tag="On-Demand">WATCH NOW</span>
                              </a>
                              <a
                                v-if="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeID ==
                                    GlobalKeysData.OnDemandTypeID &&
                                  !singleSession.IsLive
                                "
                                href="javascript:void(0)"
                                id="bk_161353"
                                v-bind:class="
                                  'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                  singleSession.LinkClass
                                "
                                data-toggle="tooltip"
                                data-placement="top"
                                v-bind:title="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeName
                                "
                                v-bind:data-original-title="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeName
                                "
                              >
                                <img
                                  src="../assets/Images/on-demand-white.svg"
                                />
                                <span>{{
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeName
                                }}</span>
                              </a>
                              &nbsp;
                              <a
                                v-if="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeID ==
                                    GlobalKeysData.LiveStreamTypeID &&
                                  singleSession.IsLive
                                "
                                id="linkRoundTableTopic"
                                v-bind:class="
                                  'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                  singleSession.LinkClass
                                "
                                v-on:click="
                                  ShowBroadCastPg(
                                    singleSession.SessionId,
                                    GlobalKeysData.IsVideoInNewTab,
                                    'video',
                                    eventId,
                                    GlobalKeysData.IsOpenInternalPlayer
                                  )
                                "
                                data-toggle="tooltip"
                                data-placement="top"
                                data-tag="live"
                              >
                                <img
                                  src="../assets/Images/live-stream-white.svg"
                                />
                                <span>{{
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeName
                                }}</span>
                              </a>
                              <a
                                v-if="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeID ==
                                    GlobalKeysData.LiveStreamTypeID &&
                                  !singleSession.IsLive
                                "
                                id="linkRoundTableTopic"
                                v-bind:class="
                                  'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                  singleSession.LinkClass
                                "
                                data-toggle="tooltip"
                                data-placement="top"
                                data-tag="live"
                              >
                                <img
                                  src="../assets/Images/live-stream-white.svg"
                                />
                                <span>{{
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeName
                                }}</span> </a
                              >&nbsp;
                              <a
                                href="javascript:void(0)"
                                v-on:click="
                                  goForlivestage(
                                    sessionRow.SessionCollection[index]
                                      .SessionId,
                                    singleSession.SessionTypeDetails
                                      .RoundTableTopic.TopicId
                                  )
                                "
                                v-else-if="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeID ==
                                    GlobalKeysData.RoundTableTypeID &&
                                  singleSession.IsLive
                                "
                                id="linkRoundTableTopic"
                                v-bind:class="
                                  'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                  singleSession.LinkClass
                                "
                                data-toggle="tooltip"
                                data-placement="top"
                                v-bind:title="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeName
                                "
                                v-bind:data-original-title="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeName
                                "
                                data-tag="roundTable"
                              >
                                <img
                                  src="../assets/Images/round-table-white.svg"
                                />
                                <span>JOIN NOW</span>
                              </a>

                              &nbsp;
                              <a
                                href="javascript:void(0)"
                                v-else-if="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeID ==
                                    GlobalKeysData.RoundTableTypeID &&
                                  !singleSession.IsLive
                                "
                                id="linkRoundTableTopic"
                                v-bind:class="
                                  'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                  singleSession.LinkClass
                                "
                                data-toggle="tooltip"
                                data-placement="top"
                                v-bind:title="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeName
                                "
                                v-bind:data-original-title="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeName
                                "
                                data-tag="roundTable"
                              >
                                <img
                                  src="../assets/Images/round-table-white.svg"
                                />
                                <span>JOIN NOW</span>
                              </a>
                              &nbsp;
                              <a
                                v-else-if="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeID ==
                                    GlobalKeysData.LivePanelTypeID &&
                                  singleSession.IsLive
                                "
                                href="javascript:void(0)"
                                v-on:click="
                                  goForGreenRoom(
                                    GlobalKeysData.videoParamsEncryptURL,
                                    GlobalKeysData.BroadcastStartURL,
                                    GlobalKeysData.BroadcastViewURL,
                                    GlobalKeysData.IsBroadcastInNewTab,
                                    sessionRow.SessionCollection[index]
                                      .SessionId,
                                    GlobalKeysData.ChannelPrefix,
                                    GlobalKeysData.BroadcastID,
                                    GlobalKeysData.BroadcastCertificate,
                                    GlobalKeysData.BroadcastSpeakerApiUrl,
                                    GlobalKeysData.BroadcastAttendeeApiUrl,
                                    GlobalKeysData.BroadcastvalidityHours,
                                    userid,
                                    eventId,
                                    'startbroadcast',
                                    sessionRow.SessionCollection[index].Name,
                                    sessionRow.SessionCollection[index]
                                      .broadcastUrlForSession,
                                    clientID,
                                    sessionRow.SessionCollection[index]
                                      .IamInThesession,
                                    GlobalKeysData.IsOpenInternalPlayer,
                                    sessionRow.SessionCollection[index]
                                      .StreamingClient,
                                    sessionRow.SessionCollection[index]
                                      .MappedHosts,
                                    sessionRow.SessionCollection[index]
                                      .MappedSpeakers,
                                    sessionRow.SessionCollection[index]
                                      .Zoom_Detail,
                                    sessionRow.SessionCollection[index]
                                      .IsZoomRTMP,
                                    sessionRow.SessionCollection[index]
                                      .ZoomRTMPMUX_detail
                                  )
                                "
                                id="start_161385"
                                v-bind:class="
                                  'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                  singleSession.LinkClass
                                "
                                data-toggle="tooltip"
                                data-placement="top"
                                v-bind:title="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeName
                                "
                                v-bind:data-original-title="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeName
                                "
                                data-tag="forGreenRoom"
                              >
                                <img
                                  src="../assets/Images/live-panel-white.svg"
                                />
                                <span>{{
                                  sessionRow.SessionCollection[index]
                                    .HasBackStageAccess
                                    ? "ENTER BACKSTAGE"
                                    : "JOIN NOW"
                                }}</span>
                              </a>
                              <a
                                v-else-if="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeID ==
                                    GlobalKeysData.LivePanelTypeID &&
                                  !singleSession.IsLive
                                "
                                href="javascript:void(0)"
                                id="start_161385"
                                v-bind:class="
                                  'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                  singleSession.LinkClass
                                "
                                data-toggle="tooltip"
                                data-placement="top"
                                v-bind:title="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeName
                                "
                                v-bind:data-original-title="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeName
                                "
                                data-tag="joinSession"
                              >
                                <img
                                  src="../assets/Images/live-panel-white.svg"
                                />
                                <span>JOIN NOW</span>
                              </a>

                              &nbsp;
                              <a
                                v-else-if="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeID ==
                                    GlobalKeysData.InPersonTypeID &&
                                  singleSession.IsLive
                                "
                                href="javascript:void(0)"
                                v-on:click="
                                  goForGreenRoom(
                                    GlobalKeysData.videoParamsEncryptURL,
                                    GlobalKeysData.BroadcastStartURL,
                                    GlobalKeysData.BroadcastViewURL,
                                    GlobalKeysData.IsBroadcastInNewTab,
                                    sessionRow.SessionCollection[index]
                                      .SessionId,
                                    GlobalKeysData.ChannelPrefix,
                                    GlobalKeysData.BroadcastID,
                                    GlobalKeysData.BroadcastCertificate,
                                    GlobalKeysData.BroadcastSpeakerApiUrl,
                                    GlobalKeysData.BroadcastAttendeeApiUrl,
                                    GlobalKeysData.BroadcastvalidityHours,
                                    userid,
                                    eventId,
                                    'startbroadcast',
                                    sessionRow.SessionCollection[index].Name,
                                    sessionRow.SessionCollection[index]
                                      .broadcastUrlForSession,
                                    clientID,
                                    sessionRow.SessionCollection[index]
                                      .IamInThesession,
                                    GlobalKeysData.IsOpenInternalPlayer,
                                    sessionRow.SessionCollection[index]
                                      .StreamingClient,
                                    sessionRow.SessionCollection[index]
                                      .MappedHosts,
                                    sessionRow.SessionCollection[index]
                                      .MappedSpeakers,
                                    sessionRow.SessionCollection[index]
                                      .Zoom_Detail,
                                    sessionRow.SessionCollection[index]
                                      .IsZoomRTMP,
                                    sessionRow.SessionCollection[index]
                                      .ZoomRTMPMUX_detail,
                                    sessionRow.SessionCollection[index]
                                      .InPersonURL
                                  )
                                "
                                id="start_161385"
                                v-bind:class="
                                  'icon-bookmark1 bmark-pupupbtn new-btn-design session-link ' +
                                  singleSession.LinkClass
                                "
                                data-toggle="tooltip"
                                data-placement="top"
                                v-bind:title="
                                  sessionRow.SessionCollection[index]
                                    .InPersonLabel
                                "
                                v-bind:data-original-title="
                                  sessionRow.SessionCollection[index]
                                    .InPersonLabel
                                "
                                data-tag="forGreenRoom"
                              >
                                <!--<img src="../assets/Images/live-panel.svg" />-->
                                <span class="session-type-icon"
                                  ><img
                                    v-bind:src="
                                      sessionRow.SessionCollection[index]
                                        .InPersonIcon
                                    "
                                /></span>
                                <span>{{
                                  sessionRow.SessionCollection[index]
                                    .InPersonLabel
                                }}</span>
                              </a>
                              <a
                                v-else-if="
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeID ==
                                    GlobalKeysData.InPersonTypeID &&
                                  !singleSession.IsLive
                                "
                                href="javascript:void(0)"
                                id="start_161385"
                                v-bind:class="
                                  'icon-bookmark1 bmark-pupupbtn new-btn-design session-link ' +
                                  singleSession.LinkClass
                                "
                                data-toggle="tooltip"
                                data-placement="top"
                                v-bind:title="
                                  sessionRow.SessionCollection[index]
                                    .InPersonLabel
                                "
                                v-bind:data-original-title="
                                  sessionRow.SessionCollection[index]
                                    .InPersonLabel
                                "
                                data-tag="joinSession"
                              >
                                <!--<img src="../assets/Images/live-panel.svg" />-->
                                <span class="session-type-icon"
                                  ><img
                                    v-bind:src="
                                      sessionRow.SessionCollection[index]
                                        .InPersonIcon
                                    "
                                /></span>
                                <span>{{
                                  sessionRow.SessionCollection[index]
                                    .InPersonLabel
                                }}</span>
                              </a>

                              <!--<div
                                v-if="
                                  IsZoomRTMPOptionsEnabled &&
                                  sessionRow.SessionCollection[index]
                                    .SessionTypeDetails.TypeID ==
                                    GlobalKeysData.LivePanelTypeID &&
                                  sessionRow.SessionCollection[index].IsLive &&
                                  sessionRow.SessionCollection[index]
                                    .IsZoomRTMP &&
                                  sessionRow.SessionCollection[index]
                                    .ZoomMeetingStarted &&
                                  (sessionRow.SessionCollection[index].IsHost ||
                                    (sessionRow.SessionCollection[index]
                                      .IsSpeaker &&
                                      sessionRow.SessionCollection[index]
                                        .ZoomRTMPStarted))
                                "
                                class="on-demand-session-option"
                              >
                                <p
                                  @click="
                                    toggleMoreSessionActions(
                                      sessionRow.SessionCollection[index]
                                        .SessionId,
                                      $event
                                    )
                                  "
                                >
                                  <span></span>
                                  <span></span>
                                  <span></span>
                                </p>
                                <div class="on-demand-dropdown d-none">
                                  <ul>
                                    <li
                                      v-if="
                                        sessionRow.SessionCollection[index]
                                          .IsHost &&
                                        sessionRow.SessionCollection[index]
                                          .ZoomMeetingStarted &&
                                        !sessionRow.SessionCollection[index]
                                          .ZoomRTMPStarted
                                      "
                                      @click="
                                        StartRTMPStreaming(
                                          sessionRow.SessionCollection[index]
                                            .SessionId,
                                          $event
                                        )
                                      "
                                    >
                                      Start RTMP Streaming
                                    </li>
                                    <li
                                      v-if="
                                        sessionRow.SessionCollection[index]
                                          .IsHost &&
                                        sessionRow.SessionCollection[index]
                                          .ZoomRTMPStarted
                                      "
                                      @click="
                                        StopRTMPStreaming(
                                          sessionRow.SessionCollection[index]
                                            .SessionId,
                                          $event
                                        )
                                      "
                                    >
                                      Stop RTMP Streaming
                                    </li>
                                    <li
                                      v-if="
                                        (sessionRow.SessionCollection[index]
                                          .IsHost ||
                                          sessionRow.SessionCollection[index]
                                            .IsSpeaker) &&
                                        sessionRow.SessionCollection[index]
                                          .ZoomRTMPStarted
                                      "
                                      @click="
                                        goForGreenRoom(
                                          GlobalKeysData.videoParamsEncryptURL,
                                          GlobalKeysData.BroadcastStartURL,
                                          GlobalKeysData.BroadcastViewURL,
                                          GlobalKeysData.IsBroadcastInNewTab,
                                          sessionRow.SessionCollection[index]
                                            .SessionId,
                                          GlobalKeysData.ChannelPrefix,
                                          GlobalKeysData.BroadcastID,
                                          GlobalKeysData.BroadcastCertificate,
                                          GlobalKeysData.BroadcastSpeakerApiUrl,
                                          GlobalKeysData.BroadcastAttendeeApiUrl,
                                          GlobalKeysData.BroadcastvalidityHours,
                                          userid,
                                          eventId,
                                          'startbroadcast',
                                          sessionRow.SessionCollection[index]
                                            .Name,
                                          sessionRow.SessionCollection[index]
                                            .broadcastUrlForSession,
                                          clientID,
                                          sessionRow.SessionCollection[index]
                                            .IamInThesession,
                                          GlobalKeysData.IsOpenInternalPlayer,
                                          sessionRow.SessionCollection[index]
                                            .StreamingClient,
                                          sessionRow.SessionCollection[index]
                                            .MappedHosts,
                                          sessionRow.SessionCollection[index]
                                            .MappedSpeakers,
                                          sessionRow.SessionCollection[index]
                                            .Zoom_Detail,
                                          sessionRow.SessionCollection[index]
                                            .IsZoomRTMP,
                                          sessionRow.SessionCollection[index]
                                            .ZoomRTMPMUX_detail,
                                          '',
                                          true
                                        )
                                      "
                                    >
                                      Interact with Audience
                                    </li>
                                  </ul>
                                </div>
                              </div>-->
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="
                          sessionRow.SessionCollection.length > 3 &&
                          sessionRow.SessionCollection.length % 3 == 2
                        "
                        style="margin-top: 60px; position: relative !important"
                        class="
                          row
                          main-divider-continue main-divider
                          visibility-hidden
                        "
                      ></div>
                      <!-- </div> -->
                    </div>
                  </div>
                  <!--sencod row ends -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--
        <add-to-calendar
          title="VueConf"
          location="WROCŁAW, POLAND"
          :start="new Date()"
          :end="new Date((new Date).setDate((new Date).getDate() + 1))"
          details="The first Official Vue.js Conference in the world!"
          inline-template
        >
          <div>
            <google-calendar id="google-calendar">
              <i class="fa fa-google"></i> Add to Google calendar
            </google-calendar>

            <microsoft-calendar id="microsoft-calendar">
              <i class="fa fa-windows"></i> Add to Microsoft live calendar
            </microsoft-calendar>

            <office365-calendar id="office365-calendar">
              <i class="fa fa-windows"></i> Add to Office365 outlook calendar
            </office365-calendar>
          </div>
        </add-to-calendar>-->
        <ComponentSessionDetails
          v-for="session in sessionListForPopup"
          :id="'session' + session.SessionID"
          v-bind:key="session.SessionID"
          v-bind:IsPlayerPopup="false"
          v-bind:SessionID="session.SessionID"
          v-bind:SessionTypeID="session.SessionTypeID"
          v-bind:IsLive="session.IsLive"
          v-bind:LinkClass="session.LinkClass"
          v-bind:TopicId="session.TopicId"
          v-bind:Title="session.Title"
          v-bind:Location="session.Location"
          v-bind:DescriptionShort="session.DescriptionShort"
          v-bind:StartTimeLabel="session.StartTimeLabel"
          v-bind:EndTimeLabel="session.EndTimeLabel"
          v-bind:StartTime="session.StartTime"
          v-bind:EndTime="session.EndTime"
          v-bind:TimeZone="timeZone"
          v-bind:Description="session.Description"
          v-bind:MappedHosts="session.MappedHosts"
          v-bind:MappedSpeakers="session.MappedSpeakers"
          v-bind:SpeakerLength="session.SpeakerLength"
          v-bind:IsUpcoming="session.IsUpcoming"
          v-bind:Resources="session.Resources"
          v-bind:IsMyAgenda="mySessions.includes(session.SessionID)"
          v-bind:AllowAddRemoveMyAgenda="AllowAddRemoveMyAgenda"
          v-bind:InPersonLabel="session.InPersonLabel"
          v-bind:InPersonIcon="session.InPersonIcon"
          v-bind:InPersonURL="session.InPersonURL"
          @onStartSession="onStartSession"
          @addToMyAgenda="addToMyAgenda"
          @removeFromMyAgenda="removeFromMyAgenda"
        ></ComponentSessionDetails>
        <ComponentspeakerDetails
          v-for="speaker in speakerDetailsForPopup"
          :id="'speaker' + speaker.AttendeeId"
          v-bind:key="speaker.AttendeeId"
          v-bind:Company="speaker.Company"
          v-bind:Designation="speaker.Designation"
          v-bind:Email="speaker.Enail"
          v-bind:Name="speaker.Name"
          v-bind:Phone="speaker.Phone"
          v-bind:ProfilePictureURL="getCDNUrl(speaker.ProfilePictureURL)"
          v-bind:Profile="speaker.Profile"
          v-bind:Initials="speaker.NameInitial"
        ></ComponentspeakerDetails>
      </section>
    </div>

    <v-dialog
      v-model="rtmpDialog.state"
      persistent
      transition="dialog-bottom-transition"
      width="800"
    >
      <rtmpComponent
        :key="rtmpDialog.key"
        ref="rtmpComponent"
        v-bind:rtmpOptions="rtmpDialog.rtmpOptions"
        @rtmpActions="rtmpActions"
      />
    </v-dialog>
    <!--persistent-->
    <!--<v-dialog
      v-model="rtmpDialog.state"
      transition="dialog-bottom-transition"
      max-width="760"
    >
      <template>
        <v-card>
          <v-toolbar
            class="pl-4"
            color="primary"
            style="box-shadow: none; background-color: #454d5d !important"
          >
            <v-toolbar-title class="text-h5 ml-2" style="color: #fff">{{
              rtmpDialog.rtmpOptions.title
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items style="height: 40px">
              <v-btn
                v-show="rtmpDialog.rtmpOptions.hasZoomLink"
                outlined
                color="white"
                class="mr-4 text-capitalize"
                style="background-color: #1a73e8"
                @click="rtmpActions(1)"
              >
                1. Join on Zoom
              </v-btn>
              <v-btn
                v-show="rtmpDialog.rtmpOptions.rtmpStartLink"
                outlined
                color="white"
                class="mr-4 text-capitalize"
                style="background-color: #1a73e8"
                :loading="rtmpDialog.rtmpOptions.startProcessing"
                @click="rtmpActions(2)"
              >
                2. Start Live Broadcast
              </v-btn>
              <v-btn
                v-show="rtmpDialog.rtmpOptions.rtmpStopLink"
                outlined
                color="white"
                class="mr-4 text-capitalize"
                style="background-color: #1a73e8"
                :loading="rtmpDialog.rtmpOptions.stopProcessing"
                @click="rtmpActions(3)"
              >
                2. Stop Live Broadcast
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container style="height: 520px; background: #454d5d !important">
            <v-row style="height: calc(100% - 80px); padding: 0 15px">
              <v-col cols="12" style="background: #000">
                <div class="text-h2 pa-12">Hello world!</div>
              </v-col>
            </v-row>
            <v-row
              class="pa-0 pt-2"
              style="
                height: 90px;
                padding: 10px 15px;
                margin: 12px 3px;
                border-radius: 0 0 15px 15px;
                background: #566074;
              "
            >
              <v-col cols="5" class="py-2 px-4">
                <v-card-text class="pa-0">
                  <div style="color: #fff" class="pb-2 text-subtitle-2">
                    The live stream is delayed by 15 - 30 secs.
                  </div>
                  <div style="color: #fff" class="pb-2 text-subtitle-2">
                    <v-icon color="white">remove_red_eye</v-icon>
                    <v-text class="ml-2 text-subtitle-1">{{
                      rtmpDialog.rtmpOptions.viewersCount
                    }}</v-text>
                  </div>
                </v-card-text>
              </v-col>
              <v-col cols="7" class="pa-0 mt-6 text-right">
                <v-btn
                  v-show="rtmpDialog.rtmpOptions.rtmpAudienceLink"
                  outlined
                  color="white"
                  class="mr-4 pa-5 text-capitalize"
                  style="background-color: #1a73e8; border-radius: 0"
                  @click="rtmpActions(4)"
                >
                  3. Live Interaction With Attendees
                </v-btn>
                <v-btn
                  outlined
                  color="white"
                  class="mr-4 pa-5 text-capitalize"
                  style="background-color: #393a3e; border-radius: 0"
                  @click="rtmpActions(-1)"
                >
                  Close
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </template>
    </v-dialog>-->
    <div
      class="modal fade modal-container"
      id="modalOpenBroadcast"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <button
            type="button"
            class="Maximize-icon"
            title="Maximize"
            v-on:click="MaximizeModal()"
          >
            <svg
              height="22px"
              viewBox="0 0 512.00533 512"
              width="22px"
              fill="#ffffff"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m10.671875 170.667969c-5.886719 0-10.66796875-4.777344-10.66796875-10.664063v-149.335937c0-5.886719 4.78124975-10.66406275 10.66796875-10.66406275h149.332031c5.890625 0 10.667969 4.77734375 10.667969 10.66406275 0 5.890625-4.777344 10.667969-10.667969 10.667969h-138.664062v138.667968c0 5.886719-4.78125 10.664063-10.667969 10.664063zm0 0"
              />
              <path
                d="m501.339844 170.667969c-5.890625 0-10.667969-4.777344-10.667969-10.664063v-138.667968h-138.667969c-5.886718 0-10.664062-4.777344-10.664062-10.667969 0-5.886719 4.777344-10.66406275 10.664062-10.66406275h149.335938c5.886718 0 10.664062 4.77734375 10.664062 10.66406275v149.335937c0 5.886719-4.777344 10.664063-10.664062 10.664063zm0 0"
              />
              <path
                d="m160.003906 512.003906h-149.332031c-5.886719 0-10.66796875-4.78125-10.66796875-10.667968v-149.332032c0-5.890625 4.78124975-10.667968 10.66796875-10.667968s10.667969 4.777343 10.667969 10.667968v138.664063h138.664062c5.890625 0 10.667969 4.78125 10.667969 10.667969 0 5.886718-4.777344 10.667968-10.667969 10.667968zm0 0"
              />
              <path
                d="m501.339844 512.003906h-149.335938c-5.886718 0-10.664062-4.78125-10.664062-10.667968 0-5.886719 4.777344-10.667969 10.664062-10.667969h138.667969v-138.664063c0-5.890625 4.777344-10.667968 10.667969-10.667968 5.886718 0 10.664062 4.777343 10.664062 10.667968v149.332032c0 5.886718-4.777344 10.667968-10.664062 10.667968zm0 0"
              />
              <path
                d="m181.339844 192.003906c-2.730469 0-5.460938-1.046875-7.554688-3.117187l-170.664062-170.664063c-4.160156-4.160156-4.160156-10.925781 0-15.085937 4.160156-4.15625 10.921875-4.15625 15.082031 0l170.667969 170.667969c4.160156 4.160156 4.160156 10.921874 0 15.082031-2.070313 2.070312-4.800782 3.117187-7.53125 3.117187zm0 0"
              />
              <path
                d="m330.671875 192.003906c-2.730469 0-5.460937-1.046875-7.550781-3.117187-4.160156-4.160157-4.160156-10.921875 0-15.082031l170.664062-170.667969c4.160156-4.15625 10.925782-4.15625 15.085938 0 4.160156 4.160156 4.160156 10.925781 0 15.085937l-170.667969 170.664063c-2.070313 2.070312-4.800781 3.117187-7.53125 3.117187zm0 0"
              />
              <path
                d="m501.339844 512.003906c-2.730469 0-5.460938-1.046875-7.554688-3.117187l-170.664062-170.664063c-4.160156-4.160156-4.160156-10.925781 0-15.085937 4.160156-4.15625 10.921875-4.15625 15.082031 0l170.667969 170.667969c4.160156 4.160156 4.160156 10.921874 0 15.082031-2.070313 2.070312-4.800782 3.117187-7.53125 3.117187zm0 0"
              />
              <path
                d="m10.671875 512.003906c-2.730469 0-5.460937-1.046875-7.550781-3.117187-4.160156-4.160157-4.160156-10.921875 0-15.082031l170.664062-170.667969c4.160156-4.15625 10.925782-4.15625 15.085938 0 4.160156 4.160156 4.160156 10.925781 0 15.085937l-170.667969 170.664063c-2.070313 2.070312-4.800781 3.117187-7.53125 3.117187zm0 0"
              />
            </svg>
          </button>
          <button
            type="button"
            class="minus"
            title="Minimize"
            v-on:click="minimizeModal()"
          >
            <svg
              version="1.1"
              id="Capa_1"
              fill="#ffffff"
              width="25px"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <g>
                <g>
                  <rect y="236" width="512" height="40" />
                </g>
              </g>
            </svg>
          </button>
          <button
            v-on:click="CloseModal()"
            type="button"
            class="close"
            title="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18.03"
              height="18.031"
              viewBox="0 0 18.03 18.031"
            >
              <path
                id="close.svg"
                fill="#ffffff"
                d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                transform="translate(-1412 -516)"
              />
            </svg>
          </button>
          <div class="modal-body">
            <iframe
              id="iframeBroadcast"
              src
              height="100%"
              width="100%"
              controls
              autoplay
              allow="camera;microphone"
            ></iframe>
          </div>
        </div>
      </div>

      <b-modal ref="my-modal" hide-footer title="Using Component Methods">
        <div class="d-block text-center"></div>
        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="hideModal"
          style="opacity: 0"
          >{{ $t("sessions.closeme") }}</b-button
        >
        <b-button
          class="mt-2"
          variant="outline-warning"
          block
          @click="toggleModal"
          style="opacity: 0"
          >{{ $t("sessions.toggleme") }}</b-button
        >
      </b-modal>
    </div>
    <!--<v-row
      style="
        z-index: 5;
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        opacity: 1;
      "
      align="center"
      justify="center"
      v-if="loaderFlg"
    >
      <v-progress-circular
        size="80"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-row>-->
    <div
      id="divLoading"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 30001;
        opacity: 1;
        transform: scale(2);
      "
    >
      <div class="loader">
        <v-progress-circular
          size="30"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>
    <!----------right attendee detail-------->
    <!-- Modal -->
    <!-- <div
      class="modal right fade speakers-popup"
      id="myModal2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel2"
    >-->
    <div
      class="modal right fade speakers-popup"
      id="myModal2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div
            class="modal-body new-addendee-list new-addendee-details px-0 pb-2"
          >
            <button
              type="button"
              id="btnModalClose"
              v-on:click="closeModal()"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>

            <!------image hld start---->
            <div class="attendee-box-hld text-center pt-0">
              <div id="dvImgeHld" class="attendee-img-hld mx-auto">
                <img id="imgModalSpeakers" class="imguserthumb" />
              </div>
              <div id="dvImgeHldText" class="attendee-img-hld mx-auto"></div>
              <span id="spnSpkEmail" style="display: none"></span>
              <span id="spnSpkPhone" style="display: none"></span>
              <div class="attendee-des-hld">
                <h3 id="modalName"></h3>
                <p id="modalCompany"></p>
                <p id="modalTtile"></p>
              </div>
              <!--------social----->
              <div class="social-icon d-flex justify-content-center">
                <a id="anchFacebook" href="#" target="_blank">
                  <span id="spnFacebook">
                    <i class="fa fa-facebook" aria-hidden="true"></i>
                  </span>
                </a>
                <a id="anchTwitter" href="#" target="_blank">
                  <span id="spnTwitter">
                    <i class="fa fa-twitter" aria-hidden="true"></i>
                  </span>
                </a>
                <a id="anchLinkedIn" href="#" target="_blank">
                  <span id="spnLinkedIn">
                    <i class="fa fa-linkedin" aria-hidden="true"></i>
                  </span>
                </a>
              </div>
              <!--------social----->
              <!--button area start--->
              <div class="button-area-hld text-center btn-theme">
                <!-- <button class="btn request-meeting mt-1 border-tranprent">Request Meeting</button> -->
                <button
                  @click="OpenRequestMeeting"
                  data-target="#calendarModal"
                  data-toggle="modal"
                  v-show="ShowMeetingButton"
                  class="
                    btn
                    request-meeting
                    mt-1
                    border-stranprent border-tranprent
                  "
                >
                  {{ $t("sessions.requestmeeting") }}
                </button>
                <button
                  v-show="ShowSendMessageButton"
                  class="btn send-message ml-2 mt-1 request-meeting"
                >
                  {{ $t("sessions.sendmessage") }}
                </button>
              </div>
              <!---button area end-->
              <!-----tab-area------->
              <div class="speakers-detailstab session-list-wrapper">
                <ul
                  role="tablist"
                  id="ulTabList"
                  class="nav nav-tabs session-nav-tab text-uppercase"
                >
                  <li class="nav-item">
                    <a
                      data-toggle="tab"
                      href="#Biograply"
                      data-tag
                      class="nav-link active"
                      >{{ $t("sessions.biography") }}</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      data-toggle="tab"
                      href="#Session"
                      data-tag
                      class="nav-link"
                      >{{ $t("sessions.sessions") }}</a
                    >
                  </li>
                  <li class="nav-item" id="liResourceTab">
                    <a
                      data-toggle="tab"
                      href="#SpkModalResource"
                      data-tag
                      class="nav-link"
                      >{{ $t("sessions.resources") }}</a
                    >
                  </li>
                </ul>
              </div>
              <!-----tab conten  startt----->
              <div class="tab-content mt-3">
                <!--Biograply tab content start--->
                <div id="Biograply" class="tab-pane active">
                  <div id="modalProfile" class="text-left"></div>
                </div>
                <!------session tab start-->

                <div id="Session" class="tab-pane text-left">
                  <!-- <div class="session-tab-innerBox p-3 mb-2">
                    <h5 class>Testing Singapore Event</h5>
                    <p class="event-date">Jul 16 11:30 to Aug 31 15:30 Asia/Calcutta</p>
                  </div>
                  <div class="session-tab-innerBox p-3 mb-2">
                    <h5 class>Testing Singapore Event</h5>
                    <p class="event-date">Jul 16 11:30 to Aug 31 15:30 Asia/Calcutta</p>
                  </div>-->
                </div>
                <!------>
                <!------Resource tab start-->

                <div id="SpkModalResource" class="tab-pane text-left"></div>
              </div>
              <!----tab content wrapper end--->
            </div>
            <!------image hld end---->
          </div>
        </div>
        <!-- modal-content -->
      </div>
      <!-- modal-dialog -->
    </div>
    <!-- modal -->

    <!----------right attendee detail-------->
    <!----------Start RequestMeeting popup-------->
    <RequestMeeting></RequestMeeting>

    <!----------Start RequestMeeting popup-------->
    <div
      id="RetryJoinInZoom"
      class="modal fade"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 400px">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>

            <div class="retry-modal p-4">
              <p style="font-size: 20px; font-weight: 600; color: #1e1f26">
                Please try again.
              </p>
              <div>
                <a
                  href="javascript:void(0)"
                  class="button-no"
                  @click="cancelRetryJoinInZoom"
                  >Cancel</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="retryJoinInZoom"
                  >Retry</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import jQuery from "jquery";
let $ = jQuery;
import db from "../components/firebaseInit";
import APIs from "../components/APIInit";
import ComponentSessionDetails from "@/components/ComponentSessionDetails.vue";
import ComponentspeakerDetails from "@/components/ComponentspeakerDetails.vue";
import rtmpComponent from "@/components/RTMPComponent.vue";
import analytics from "@/components/Analytics";
import axios from "axios";
import common from "@/common";
import { bus } from "@/main";

var monthNamesShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
var sessionStatusRefreshTimer;
var zoomRTMPRefreshTimer;
var ZoomRTMPParticipantsListener;
var self;
import RequestMeeting from "@/components/RequestMeeting.vue";
import router from "../router";

export default {
  components: {
    //TopMenu,
    RequestMeeting,
    ComponentSessionDetails,
    ComponentspeakerDetails,
    rtmpComponent,
  },
  data() {
    return {
      rtmpDialog: {
        key: 0,
        lastUpdateTimeStamp: 0,
        sessionId: "",
        session: null,

        rtmpOptions: {
          title: "Welcome",
          state: false,
          startProcessing: false,
          stopProcessing: false,
          sessionId: "",
          uid: "",
          event_collectionName: "",

          hasZoomLink: false,
          rtmpStartLink: false,
          rtmpStopLink: false,
          rtmpAudienceLink: false,
          viewersCount: 0,
          zoomUrl: "",
          streamUrl: "",
          ZoomMeetingStarted: false,
          ZoomRTMPStarted: false,
          chatEnabled: false,
          qnaEnabled: false,
          //attendeeEnabled: false,
        },
      },
      speakerEvent: null,
      ipadScreen: false,
      headerText: "LIVE STAGE",
      ShowMeetingButton: false,
      ShowSendMessageButton: false,
      attendeeData: [],
      sessionTabList: [], //for tab only
      sessionContentList: [], //for sesssion content
      sessionListForPopup: [],
      speakerDetailsForPopup: [],
      eventId: "",
      userid: "",
      name: "",
      email: "",
      firstName: "",
      lastName: "",
      timeZone: "",
      allSpeakers: [],
      allTracks: [],
      GlobalKeysData: {
        IsOpenInternalPlayer: 1,
        IsBroadcastInNewTab: 1,
        IsVideoInNewTab: 0,
        BroadcastID: "605f401455444442838e00cb859c037b",
        BroadcastCertificate: "8f472eef21f64cba97c105eab797522f",
        BroadcastSpeakerApiUrl:
          "https://onairapi.e2m.live/get-session-token-speaker",
        BroadcastAttendeeApiUrl:
          "https://onairapi.e2m.live/get-session-token-attendee",
        BroadcastStartURL: "https://onair2.e2m.live/video/live-broadcast.html",
        BroadcastViewURL: "https://onair2.e2m.live/video/live-audience.html",
        BroadcastvalidityHours: "72",
        ChannelPrefix: "OAUAT",
        OnDemandTypeID: 1,
        LiveStreamTypeID: 2,
        LivePanelTypeID: 3,
        RoundTableTypeID: 4,
        InPersonTypeID: 5,
        videoParamsEncryptURL: "https://awsapi.e2m.live/encrypt-call-params",
      },
      clientID: this.$store.getters.getClient[0].id,
      //eventcollection:
      //  this.$store.getters.getEventCollection.eventcollectionname,
      eventcollection: "",

      spkrLimit: 5,
      //isSpeakerUser: false
      textColor: "black",
      allSessions: [],
      mySessions: [],
      sessionsLoaded: false,
      sessionSettingsLoaded: false,
      mySessionsLoaded: false,
      selectedAgendaType: 0, // 0:FULL AGENDA, 1:MY AGENDA
      AgendaFilterOption: 0, // 0: FullAgendaOnly (Default), 1: MyAgendaOnly, 2: ShowAll
      AllowAddRemoveMyAgenda: false,
      selectedTabId: "",
      selectedStartDate: null,
      selectedEndDate: null,
      //tabObjList: [],
      dateTabs: [],
      selectedTabSessions: [],
      tempSession: null,
      selectedDateValue: null,
      IsZoomRTMPOptionsEnabled: false,
      RestrictedZoomMeetingEnabled: true,
      loaderFlg: false,
      trackId: "",
      trackName: "",
      localTimeZone: "",
    };
  },
  computed: {
    rtmpComponent() {
      return self.$refs.rtmpComponent.rtmpComp;
    },
  },
  watch: {
    "rtmpDialog.lastUpdateTimeStamp"() {
      if (self.rtmpDialog.session) {
        let session = self.rtmpDialog.session;
        self.rtmpDialog.rtmpOptions.hasZoomLink = false;
        self.rtmpDialog.rtmpOptions.rtmpStartLink = false;
        self.rtmpDialog.rtmpOptions.rtmpStopLink = false;
        self.rtmpDialog.rtmpOptions.rtmpAudienceLink = false;
        self.rtmpDialog.rtmpOptions.ZoomMeetingStarted =
          session.ZoomMeetingStarted;
        self.rtmpDialog.rtmpOptions.ZoomRTMPStarted = session.ZoomRTMPStarted;
        if (session.IsZoomRTMP) {
          if (session.IsHost || session.IsSpeaker) {
            self.rtmpDialog.rtmpOptions.hasZoomLink = true;
          }
          if (session.IsHost) {
            self.rtmpDialog.rtmpOptions.rtmpStartLink = true;
          }
          if (session.IsHost && session.ZoomRTMPStarted) {
            self.rtmpDialog.rtmpOptions.rtmpStopLink = true;
          }
          if (session.ZoomRTMPStarted) {
            self.rtmpDialog.rtmpOptions.rtmpAudienceLink = true;
          }
        }
      }
    },
    speakerEvent(val) {
      if (val) {
        this.$store.commit("addEventCollection", val.iceId);
        this.$store.commit("addEventID", val.EventId);
        this.getSessions();
      }
    },
    selectedAgendaType: function () {},
    selectedTabId: function () {},
    sessionSettingsLoaded: function () {
      if (self.sessionsLoaded && self.mySessionsLoaded) {
        self.initAgendaFilterOption();
      }
    },
    sessionsLoaded: function () {
      if (self.sessionSettingsLoaded && self.mySessionsLoaded) {
        self.initAgendaFilterOption();
      }
    },
    mySessionsLoaded: function () {
      if (self.sessionsLoaded && self.sessionSettingsLoaded) {
        self.initAgendaFilterOption();
      }
    },
  },
  beforeCreate() {
    //if (!self) {
    //  self = this;
    //}
  },
  created() {
    self = this;
    if (self.$route.params.tid) {
      self.trackId = self.$route.params.tid;
    }
    if (self.$route.params.tname) {
      self.trackName = self.$route.params.tid;
    }
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if (obj) {
      self.eventcollection = obj.eventcollectionname;
    }
    self.localTimeZone = common.getTimeZoneName();
  },
  async beforeRouteUpdate(to, from, next) {
    next(true);
    self.trackId = "";
    if (self.$route.params.tid) {
      self.trackId = self.$route.params.tid;
    }
    self.trackName = "";
    if (self.$route.params.tname) {
      self.trackName = self.$route.params.tid;
    }
    self.getSessions();
  },
  async mounted() {
    self.getSessions();
  },
  beforeDestroy() {
    self.speakerDetailsForPopup = [];
    self.allSpeakers = [];
    self.searchtext = "";

    if (sessionStatusRefreshTimer) {
      clearInterval(sessionStatusRefreshTimer);
    }
    if (zoomRTMPRefreshTimer) {
      clearInterval(zoomRTMPRefreshTimer);
    }
    if (ZoomRTMPParticipantsListener) {
      ZoomRTMPParticipantsListener();
      ZoomRTMPParticipantsListener = null;
    }
  },
  methods: {
    async getSessions() {
      self.allSessions = [];
      self.mySessions = [];
      self.selectedTabSessions = [];
      self.sessionsLoaded = false;
      self.sessionSettingsLoaded = false;
      self.mySessionsLoaded = false;
      self.sessionContentList = [];
      db.collection("OA_UAT")
        .doc("GeneralSettings")
        .get()
        .then(function (doc) {
          if (doc.exists) {
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.IsZoomRTMPOptionsEnabled
            ) {
              self.IsZoomRTMPOptionsEnabled =
                doc.data().PlayerSettings.IsZoomRTMPOptionsEnabled;
            }
          }
        });
      if (screen.width >= 768 && screen.width <= 1024) {
        self.ipadScreen = true;
        common.checkAppDownloadScreenByDevice("ipad");
      } else if (screen.width < 767) {
        common.checkAppDownloadScreenByDevice("mobile");
      }
      self.ShowMeetingButton = false;
      self.ShowSendMessageButton = false;
      /*++++++++ Header color Brancing JSON ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      //$("#topmenu").show();
      //$("#leftmenu").show();
      common.toggleTopMenu(true);
      common.toggleLeftMenu(true);
      $("#btnAddUserView").click();
      if (obj) {
        self.eventcollection = obj.eventcollectionname;
        if (obj.user && obj.user.length > 0) {
          self.name = obj.user[0].name;
          self.email = obj.user[0].Email;
          self.firstName = obj.user[0].fname;
          self.lastName = obj.user[0].lname;
          self.userid = obj.user[0].id;
          self.timeZone = obj.tzone;
          db.collection(obj.eventcollectionname)
            .doc("Settings")
            .collection("Sessions")
            .doc("SessionsSettings")
            .get()
            .then((doc) => {
              if (doc.exists) {
                var data = doc.data();
                if (data.AgendaFilterOption != undefined) {
                  self.AgendaFilterOption = parseInt(data.AgendaFilterOption);
                }
                if (data.AllowAddRemoveMyAgenda != undefined) {
                  self.AllowAddRemoveMyAgenda = data.AllowAddRemoveMyAgenda;
                }
              }
              if (self.AgendaFilterOption == 0) {
                self.mySessionsLoaded = true;
              } else {
                self.prepareMySession();
              }

              self.sessionSettingsLoaded = true;
            });
        }
      }
      //-------------dynamic font selection --------------------------------------
      if (obj.EventFont != undefined) {
        if (obj.EventFont.length > 0) {
          var urlpath = "";
          if (obj.EventFont[0].FontPath != "") {
            if (obj.EventFont[0].FontFamily != "") {
              urlpath = obj.EventFont[0].FontPath;

              var newStyle = document.createElement("style");
              newStyle.appendChild(
                document.createTextNode(
                  "\
@font-face {\
    font-family: " +
                    obj.EventFont[0].FontFamily +
                    ";\
    src:" +
                    urlpath +
                    " ;\
}\
"
                )
              );

              document.head.appendChild(newStyle);

              $(
                "<style>* { font-family: '" +
                  obj.EventFont[0].FontFamily +
                  "' !important }</style>"
              ).appendTo("head");
            }
          } else {
            $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
              "head"
            );
          }
        }
      }
      //-------------dynamic font selection --------------------------------------
      //-------Page Title-------------
      self.headerText = "Sessions";
      db.collection(obj.eventcollectionname)
        .doc("Menu")
        .get()
        .then((doc) => {
          var data = doc.data();
          $.each(data.AllMenu, function (key, value) {
            if (value.GroupID != 99) {
              if (value.Name == "Sessions") {
                if (self.$store.state.locale == "English") {
                  self.headerText = value.DisplayLabel;
                } else if (self.$store.state.locale == "German") {
                  self.headerText = value.DisplayLabel_de;
                } else if (self.$store.state.locale == "French") {
                  self.headerText = value.DisplayLabel_fr;
                } else if (self.$store.state.locale == "Chinese") {
                  self.headerText = value.DisplayLabel_zh;
                } else {
                  self.headerText = value.DisplayLabel;
                }
                document.title = self.headerText + " - " + obj.eventname;
                document.getElementById("headerText").innerText =
                  self.headerText;
              }
            }
          });
          $.each(data.LeftMenu, function (key, value) {
            if (value.GroupID != 99) {
              if (value.Name == "Sessions") {
                if (self.$store.state.locale == "English") {
                  self.headerText = value.DisplayLabel;
                } else if (self.$store.state.locale == "German") {
                  self.headerText = value.DisplayLabel_de;
                } else if (self.$store.state.locale == "French") {
                  self.headerText = value.DisplayLabel_fr;
                } else if (self.$store.state.locale == "Chinese") {
                  self.headerText = value.DisplayLabel_zh;
                } else {
                  self.headerText = value.DisplayLabel;
                }
                document.title = self.headerText + " - " + obj.eventname;
                document.getElementById("headerText").innerText =
                  self.headerText;
              }
            }
          });
          document.getElementById("headerText").innerText = self.headerText;
        });
      document.getElementById("headerText").innerText = self.headerText;

      //-------------------FAVICONJOB------------------------------------------------------------
      if (obj.branding[0].favicon != undefined) {
        if (obj.branding[0].favicon != "") {
          var link =
            document.querySelector("link[rel*='icon']") ||
            document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = obj.branding[0].favicon;
          document.getElementsByTagName("head")[0].appendChild(link);
        }
      }
      //----------------------------------------------------------------------------------
      var brandingData;
      try {
        brandingData = await self.getBrandingJSONDetails(
          obj.eventcollectionname + "/Branding/Branding.json"
        );
        if (brandingData.data != undefined) {
          if (brandingData.data.EventInfo != undefined) {
            if (brandingData.data.EventInfo.BodyTextColor != undefined) {
              self.textColor = brandingData.data.EventInfo.BodyTextColor;
            } else {
              self.textColor = "black";
            }
          } else {
            self.textColor = "black";
          }
          console.log("BodyTextColor :- " + self.textColor);
          $("#headerText").css("color", self.textColor);
        }
      } catch (e) {
        console.log("Error in Branding Json Fetch--", e);
      }

      //------------------------------------------------------------------------------
      if (obj.EventBranding != undefined) {
        if (obj.EventBranding[0].banner != undefined) {
          if (obj.EventBranding[0].banner != "") {
            $("#imgBanner").attr("src", obj.EventBranding[0].banner);
          }
        }
      }
      self.eventId = obj.eventid;
      self.scroll();
      self.prepareSessionTabData();
      self.setFirebaseAppsettings();
      $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
      $("#sectionId").css(
        "background-image",
        "url(" + obj.EventBranding[0].eventBGImage + ")"
      );
      if (obj !== undefined) {
        if (obj !== null) {
          if (obj.EventBranding[0] !== undefined) {
            $("#divBannerTop").css(
              "background-color",
              obj.EventBranding[0].topBar
            );
          }
        }
      }

      self.getSpeakerSettings();
    },
    getWidth() {
      let width = document.getElementById("leftmenu")
        ? document.getElementById("ulLeftMenu").offsetWidth
        : 0;
      return `width:calc(100% - ${width}px) !important`;
    },
    rowClassCss(index) {
      if (index < 2) return "row main-divider my-0 py-0 mr-2";
      else return "row main-divider my-0 py-0";
    },
    trackColor(trackId) {
      let color = "";
      let track = self.allTracks.filter(function (item) {
        return item.TrackId == trackId;
      });
      if (track.length > 0) {
        color = track[0].ColorCode ? track[0].ColorCode : "#d7d7ea";
      }
      return color;
    },
    addToMyAgenda: function (sessionId) {
      $("#addToMyAgenda_" + sessionId).html("Processing...");
      $("#addToMyAgenda_" + sessionId).attr("disabled");
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let attendees = [
        {
          AttendeeId: self.userid,
          Email: self.email,
          FirstName: self.firstName,
          LastName: self.lastName,
          Name: self.name,
        },
      ];
      let currentSessions = self.allSessions.filter(function (item) {
        return item.SessionId == sessionId;
      });
      if (currentSessions.length > 0) {
        let sessions = [
          {
            EndDate: new Date(
              currentSessions[0].EndDate.seconds * 1000
            ).toUTCString(),
            Name: currentSessions[0].Name,
            SessionId: sessionId,
            StartDate: new Date(
              currentSessions[0].StartDate.seconds * 1000
            ).toUTCString(),
            Track: currentSessions[0].Track,
          },
        ];
        let requestData = {
          source: "web",
          //"token": accessToken,
          key: {
            instanceId: "OA_UAT",
            clientId: self.clientID,
            eventId: self.eventId,
          },
          data: {
            sessions: sessions,
            map: {
              attendees: attendees,
              groups: [],
            },
            unmap: {
              attendees: [],
              groups: [],
            },
          },
        };
        axios
          .put(APIs.SessionAttendeeMappingAPI, requestData, {
            headers: headers,
          })
          .then((response) => {
            //alert(response);
            console.log(response);
            if (!self.mySessions.includes(sessionId)) {
              self.mySessions.push(sessionId);
            }
            $("#addToMyAgenda_" + sessionId).html("Add to My Agenda");
            $("#addToMyAgenda_" + sessionId).removeAttr("disabled");
            self.setupCurrentTabs();
            self.setupCurrentTabSessions();
          })
          .catch((error) => {
            console.log(error);
            $("#addToMyAgenda_" + sessionId).html("Add to My Agenda");
            $("#addToMyAgenda_" + sessionId).removeAttr("disabled");
          });
      }
    },
    removeFromMyAgenda: function (sessionId) {
      $("#removeFromMyAgenda_" + sessionId).html("Processing...");
      $("#removeFromMyAgenda_" + sessionId).attr("disabled");
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let attendees = [
        {
          AttendeeId: self.userid,
          Email: self.email,
          FirstName: self.firstName,
          LastName: self.lastName,
          Name: self.name,
        },
      ];
      let currentSessions = self.allSessions.filter(function (item) {
        return item.SessionId == sessionId;
      });
      if (currentSessions.length > 0) {
        let sessions = [
          {
            EndDate: new Date(
              currentSessions[0].EndDate.seconds * 1000
            ).toUTCString(),
            Name: currentSessions[0].Name,
            SessionId: sessionId,
            StartDate: new Date(
              currentSessions[0].StartDate.seconds * 1000
            ).toUTCString(),
            Track: currentSessions[0].Track,
          },
        ];
        let requestData = {
          source: "web",
          //"token": accessToken,
          key: {
            instanceId: "OA_UAT",
            clientId: self.clientID,
            eventId: self.eventId,
          },
          data: {
            sessions: sessions,
            map: {
              attendees: [],
              groups: [],
            },
            unmap: {
              attendees: attendees,
              groups: [],
            },
          },
        };
        axios
          .put(APIs.SessionAttendeeMappingAPI, requestData, {
            headers: headers,
          })
          .then((response) => {
            console.log(response);
            if (self.mySessions.includes(sessionId)) {
              self.mySessions = self.mySessions.filter(function (val) {
                return val != sessionId;
              });
              if (self.mySessions.length == 0 && self.selectedAgendaType == 1) {
                self.selectedAgendaType = 0;
              }
            }
            $("#removeFromMyAgenda_" + sessionId).html("Remove from My Agenda");
            $("#removeFromMyAgenda_" + sessionId).removeAttr("disabled");
            self.setupCurrentTabs();
            self.setupCurrentTabSessions();
          })
          .catch((error) => {
            console.log(error);
            $("#removeFromMyAgenda_" + sessionId).html("Remove from My Agenda");
            $("#removeFromMyAgenda_" + sessionId).removeAttr("disabled");
          });
      }
    },
    initAgendaFilterOption: function () {
      if (self.AgendaFilterOption == 0 || self.AgendaFilterOption == 2) {
        self.selectedAgendaType = 0;
      } else if (self.AgendaFilterOption == 1) {
        self.selectedAgendaType = 1;
      }
      self.setupCurrentTabs();
      self.hideLoader();
      setTimeout(() => {
        if (sessionStatusRefreshTimer) {
          clearInterval(sessionStatusRefreshTimer);
        }
        sessionStatusRefreshTimer = setInterval(function () {
          if (self.sessionContentList.length > 0) {
            self.updateSessionStatus();
          }
        }, 2000);
      }, 5000);
    },
    onAgendaTypeChanged(agendaType) {
      self.selectedAgendaType = agendaType;
      //self.selectedStartDate = null;
      //self.selectedEndDate = null;
      self.setupCurrentTabs();
    },
    onTabChange: function (tabId, startDate, endDate) {
      self.selectedTabId = tabId;
      self.selectedStartDate = startDate;
      self.selectedEndDate = endDate;
      $(".session-tab-wrapper .nav-link").removeClass("active");
      $("#a_" + tabId).addClass("active");
      self.setupCurrentTabSessions();
    },
    mobileDropdownChange() {
      console.log("sd========", self.selectedDateValue);
      console.log("dt========", self.dateTabs);
      self.dateTabs.filter(function (tab) {
        if (tab.DateTabId == self.selectedDateValue) {
          self.onTabChange(tab.DateTabId, tab.StartTime, tab.EndTime);
        }
      });
    },
    setupCurrentTabs() {
      let tabList = [];
      let tabObjList = [];
      self.allSessions.forEach(function (item) {
        let flag = true;
        if (
          (self.AgendaFilterOption == 1 || self.AgendaFilterOption == 2) &&
          self.selectedAgendaType == 1
        ) {
          flag = false;
          if (self.mySessions.includes(item.SessionId)) {
            flag = true;
          }
        }
        if (flag) {
          let dtt = new Date(item.StartTime * 1000);
          var dtYear = dtt.getFullYear();
          var dtMonth = dtt.getMonth();
          var dtDay = dtt.getDate();
          let startDate = new Date(dtYear, dtMonth, dtDay);
          dtt = new Date((item.EndTime - 1) * 1000);
          dtYear = dtt.getFullYear();
          dtMonth = dtt.getMonth();
          dtDay = dtt.getDate();
          //let endDate = new Date(dtYear, dtMonth, dtDay, 23, 59, 59);
          let endDate = new Date(dtYear, dtMonth, dtDay + 1, 0, 0, 0);

          while (startDate < endDate) {
            let dateTabLabel = startDate.toString().substring(0, 10);
            if (!tabList.includes(dateTabLabel)) {
              tabList.push(dateTabLabel);
              let dateTabId =
                "menu" + dateTabLabel.replace(" ", "").replace(" ", "");

              let tabObj = {
                DateTabLabel: dateTabLabel,
                DateTabId: dateTabId,
                CurrentClass: "",
                StartTime: parseInt(startDate.getTime() / 1000),
                SDT: startDate.toString(),
              };
              startDate.setDate(startDate.getDate() + 1);
              tabObj.EndTime = parseInt(startDate.getTime() / 1000);
              tabObj.EDT = startDate.toString();
              tabObjList.push(tabObj);
              console.log(tabObj);
            } else {
              startDate.setDate(startDate.getDate() + 1);
            }
          }
          //if (!tabList.includes(item.DateTabLabel)) {
          //  tabList.push(item.DateTabLabel);

          //  let dateTabId =
          //    "menu" + item.DateTabLabel.replace(" ", "").replace(" ", "");

          //  tabObjList.push({
          //    DateTabLabel: item.DateTabLabel,
          //    DateTabId: dateTabId,
          //    CurrentClass: "",
          //  });

          //  //tbObj.StartDate = new Date(dtYear, dtMonth, dtDay);

          //  //tbObj.StartTime = tbObj.StartDate.getTime();
          //  //tbObj.EndDate = new Date(dtYear, dtMonth, dtDay);
          //  //tbObj.EndDate.setDate(tbObj.EndDate.getDate() + 1);
          //  //tbObj.EndTime = tbObj.EndDate.getTime();
          //  //tbObj.CurrentClass = "";
          //}

          //}
        }
      });

      tabObjList.map(function (tab) {
        tab.CurrentClass = "";
      });

      tabObjList.map(function (tab) {
        if (tab.DateTabId == self.selectedTabId) {
          tab.CurrentClass = "active";
        }
      });
      var selectedTabs = tabObjList.filter(function (tab) {
        return tab.DateTabId == self.selectedTabId;
      });
      if (selectedTabs.length == 0) {
        let currentTime = parseInt(new Date().getTime() / 1000);

        var tabSelected = false;
        var tIndx = 0;
        var todaysTab = tabObjList.filter(function (tab) {
          return currentTime >= tab.StartTime && currentTime < tab.EndTime;
        });
        if (todaysTab.length > 0) {
          for (tIndx = 0; tIndx < tabObjList.length; tIndx++) {
            if (
              currentTime >= tabObjList[tIndx].StartTime &&
              currentTime <= tabObjList[tIndx].EndTime
            ) {
              tabObjList[tIndx].CurrentClass = "active";
              //self.sessionContentList[tIndx].CurrentClass = "active";
              tabSelected = true;
              //self.selectedStartDate = tabObjList[tIndx].StartTime;
              //self.selectedEndDate = tabObjList[tIndx].EndTime;
              break;
            }
          }
        }

        if (!tabSelected) {
          var upCommingTab = tabObjList.filter(function (tab) {
            return currentTime < tab.StartTime;
          });
          if (upCommingTab.length > 0) {
            for (tIndx = 0; tIndx < tabObjList.length; tIndx++) {
              if (currentTime < tabObjList[tIndx].StartTime) {
                tabObjList[tIndx].CurrentClass = "active";
                //self.sessionContentList[tIndx].CurrentClass = "active";
                tabSelected = true;
                //self.selectedStartDate = tabObjList[tIndx].StartTime;
                //self.selectedEndDate = tabObjList[tIndx].EndTime;
                break;
              }
            }
          }
        }

        if (!tabSelected) {
          var finishedTab = tabObjList.filter(function (tab) {
            return currentTime > tab.EndTime;
          });
          if (finishedTab.length > 0) {
            for (tIndx = tabObjList.length - 1; tIndx >= 0; tIndx--) {
              if (currentTime > tabObjList[tIndx].EndTime) {
                tabObjList[tIndx].CurrentClass = "active";
                //self.sessionContentList[tIndx].CurrentClass = "active";
                tabSelected = true;
                //self.selectedStartDate = tabObjList[tIndx].StartTime;
                //self.selectedEndDate = tabObjList[tIndx].EndTime;
                break;
              }
            }
          }
        }
      }
      selectedTabs = tabObjList.filter(function (tab) {
        return tab.CurrentClass == "active";
      });
      if (selectedTabs.length > 0) {
        self.onTabChange(
          selectedTabs[0].DateTabId,
          selectedTabs[0].StartTime,
          selectedTabs[0].EndTime
        );
      }
      self.dateTabs = tabObjList;
    },
    setupCurrentTabSessions() {
      let sessionContentList = [];
      let sessionTabList = [];
      self.selectedTabSessions = [];
      self.allSessions.forEach(function (item) {
        let flag = true;
        if (
          (self.AgendaFilterOption == 1 || self.AgendaFilterOption == 2) &&
          self.selectedAgendaType == 1
        ) {
          flag = false;
          if (self.mySessions.includes(item.SessionId)) {
            flag = true;
          }
        }
        if (flag) {
          if (
            (item.StartTime < self.selectedStartDate &&
              item.EndTime > self.selectedEndDate) ||
            (item.StartTime >= self.selectedStartDate &&
              item.StartTime <= self.selectedEndDate) ||
            (item.EndTime >= self.selectedStartDate &&
              item.EndTime <= self.selectedEndDate)
          ) {
            var dateTabLabel;
            let dtt = new Date(self.selectedStartDate * 1000);
            var dtYear = dtt.getFullYear();
            var dtMonth = dtt.getMonth();
            var dtDay = dtt.getDate();
            dateTabLabel = dtt.toString().substring(0, 10);
            let tabStartTime = parseInt(
              new Date(dtYear, dtMonth, dtDay).getTime() / 1000
            );
            let tabEndDate = new Date(dtYear, dtMonth, dtDay);
            tabEndDate.setDate(tabEndDate.getDate() + 1);
            let tabEndTime = parseInt(tabEndDate.getTime() / 1000);

            let sessionStartTime = item.StartTime;
            let sessionEndTime = item.EndTime;
            if (sessionStartTime < tabStartTime) {
              sessionStartTime = tabStartTime;
            }
            if (sessionEndTime > tabEndTime) {
              sessionEndTime = tabEndTime;
            }
            if (sessionEndTime - sessionStartTime > 0) {
              var sessionTab = sessionTabList.filter(function (value) {
                return value.DateTabLabel == dateTabLabel;
              });

              if (sessionTab.length == 0) {
                var tbObj = new Object();

                tbObj.DateTabLabel = dateTabLabel; //display date tab format
                tbObj.DateTabId =
                  "menu" + tbObj.DateTabLabel.replace(" ", "").replace(" ", "");
                tbObj.StartDate = new Date(dtYear, dtMonth, dtDay);

                tbObj.StartTime = parseInt(tbObj.StartDate.getTime() / 1000);
                tbObj.EndDate = new Date(dtYear, dtMonth, dtDay);
                tbObj.EndDate.setDate(tbObj.EndDate.getDate() + 1);
                tbObj.EndTime = parseInt(tbObj.EndDate.getTime() / 1000);
                tbObj.CurrentClass = "";

                sessionTabList.push(tbObj);

                var sessionContentObj = new Object();
                sessionContentObj.DateTabLabel = dateTabLabel;
                sessionContentObj.DateTabId =
                  "menu" +
                  sessionContentObj.DateTabLabel.replace(" ", "").replace(
                    " ",
                    ""
                  );
                sessionContentObj.CurrentClass = "";
                sessionContentObj.SessionRowList = [];
                sessionContentList.push(sessionContentObj);
              }

              //header datetab construct ends
              //session content start

              var sessionContents = sessionContentList.filter(function (value) {
                return value.DateTabLabel == dateTabLabel;
              });
              if (sessionContents.length != 0) {
                var sessionTabIndex = sessionContentList.indexOf(
                  sessionContents[0]
                );

                var filteredRows = sessionContentList[
                  sessionTabIndex
                ].SessionRowList.filter(function (value) {
                  //return (
                  //  value.StartTime == item.StartTime &&
                  //  value.EndTime == item.EndTime
                  //);
                  return (
                    (value.StartTime == item.StartTime ||
                      value.StartTime <= tabStartTime) &&
                    (value.EndTime == item.EndTime ||
                      value.EndTime >= tabEndTime)
                  );
                });
                if (filteredRows.length == 0) {
                  var objRow = new Object();
                  objRow.StartTime = item.StartTime;
                  objRow.StartTimeLabel =
                    self.getFormattedTime(sessionStartTime);
                  objRow.EndTime = item.EndTime;
                  objRow.EndTimeLabel = self.getFormattedTime(sessionEndTime);
                  objRow.SessionCollection = [];
                  objRow.TrackCollection = [];
                  sessionContentList[sessionTabIndex].SessionRowList.push(
                    objRow
                  );
                }
                filteredRows = sessionContentList[
                  sessionTabIndex
                ].SessionRowList.filter(function (value) {
                  //return (
                  //  value.StartTime == item.StartTime &&
                  //  value.EndTime == item.EndTime
                  //);
                  return (
                    (value.StartTime == item.StartTime ||
                      value.StartTime <= tabStartTime) &&
                    (value.EndTime == item.EndTime ||
                      value.EndTime >= tabEndTime)
                  );
                });

                if (filteredRows.length != 0) {
                  var sessionIndex = sessionContentList[
                    sessionTabIndex
                  ].SessionRowList.indexOf(filteredRows[0]);

                  sessionContentList[sessionTabIndex].SessionRowList[
                    sessionIndex
                  ].SessionCollection.push(item);
                  //-------------------------------session row ends----------------------------------------------------------------------------
                  var objTrack = new Object();
                  if (item.Track != undefined) {
                    if (item.Track.TrackName != undefined) {
                      objTrack.TrackName = item.Track.TrackName;
                      objTrack.TrackId = item.Track.TrackID;
                    }
                  }
                  sessionContentList[sessionTabIndex].SessionRowList[
                    sessionIndex
                  ].TrackCollection.push(objTrack);
                }
              }
            }
          }
        }
      });

      for (var tIndex = 0; tIndex < sessionContentList.length; tIndex++) {
        for (
          var rIndex = 0;
          rIndex < sessionContentList[tIndex].SessionRowList.length;
          rIndex++
        ) {
          //
          var rowSessCnt =
            sessionContentList[tIndex].SessionRowList[rIndex].SessionCollection
              .length;

          sessionContentList[tIndex].SessionRowList[rIndex].RowSessionCount =
            rowSessCnt;

          //sessionContentList[tIndex].SessionRowList[rIndex].StartTimeLabel =
          //  sessionContentList[tIndex].SessionRowList[
          //    rIndex
          //  ].SessionCollection[0].StartTimeLabel;
          //sessionContentList[tIndex].SessionRowList[rIndex].EndTimeLabel =
          //  sessionContentList[tIndex].SessionRowList[
          //    rIndex
          //  ].SessionCollection[0].EndTimeLabel;

          if (rowSessCnt == 1) {
            sessionContentList[tIndex].SessionRowList[rIndex].SessionClass =
              "one-session";

            sessionContentList[tIndex].SessionRowList[rIndex].TrackClass =
              "one-track";
          } else if (rowSessCnt == 2) {
            sessionContentList[tIndex].SessionRowList[rIndex].SessionClass =
              "two-session";
            sessionContentList[tIndex].SessionRowList[rIndex].TrackClass =
              "two-track";
          } else if (rowSessCnt == 3) {
            sessionContentList[tIndex].SessionRowList[rIndex].SessionClass =
              "three-session";
            sessionContentList[tIndex].SessionRowList[rIndex].TrackClass =
              "three-track";
          } else {
            sessionContentList[tIndex].SessionRowList[rIndex].SessionClass =
              "three-session flex-wrap-four";
            sessionContentList[tIndex].SessionRowList[rIndex].TrackClass =
              "three-track";
          }
        }
      }
      self.selectedTabSessions = sessionContentList.filter(function () {
        return true;
      });

      setTimeout(() => {
        $('[data-toggle="tooltip"]').tooltip();
      }, 1000);
    },
    goForlivestage(sessionId) {
      $(".tooltip").tooltip("hide");
      $(".modal").modal("hide");
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (
        screen.width < 767 &&
        obj.AgoraPlayerBrowserSupportInMobile == false
      ) {
        router.push("/screeninfo");
      } else if (
        screen.width >= 768 &&
        screen.width <= 1024 &&
        obj.AgoraPlayerBrowserSupportInIPad == false
      ) {
        router.push("/screeninfo");
      } else {
        router.push({
          path: "/roundtable/" + sessionId,
        });
      }
    },
    GoForInternalPlayer(sessionId, externalLink) {
      $(".tooltip").tooltip("hide");
      $(".modal").modal("hide");
      if (externalLink) {
        if (externalLink.startsWith("/")) {
          router.push(externalLink);
        } else {
          window.open(externalLink, "_blank");
          self.postLeaderboardAction("SNVW");
        }
      } else {
        router.push({
          path: "/livestage/" + sessionId,
        });
      }
    },
    toggleMoreSessionActions(sessionId, e) {
      if (sessionId) {
        if (
          $("#session_wrap_" + sessionId + " .on-demand-dropdown").hasClass(
            "d-none"
          )
        ) {
          $(".on-demand-dropdown").addClass("d-none");
          $("#session_wrap_" + sessionId + " .on-demand-dropdown").removeClass(
            "d-none"
          );
        } else {
          $("#session_wrap_" + sessionId + " .on-demand-dropdown").addClass(
            "d-none"
          );
        }
      } else {
        $(".on-demand-dropdown").addClass("d-none");
      }
      if (e) {
        e.stopPropagation();
      }
    },
    toggleMoreSessionActions1(sessionId, e) {
      if (sessionId) {
        if ($(e.target).siblings(".on-demand-dropdown").hasClass("d-none")) {
          $(".on-demand-dropdown").addClass("d-none");
          $(e.target).siblings(".on-demand-dropdown").removeClass("d-none");
        } else {
          $(e.target).siblings(".on-demand-dropdown").addClass("d-none");
        }
        if (e) {
          e.stopPropagation();
        }
      } else {
        $(".on-demand-dropdown").addClass("d-none");
      }
    },
    StartRTMPStreaming(sessionId, e) {
      $("#session_wrap_" + sessionId + " .on-demand-dropdown").addClass(
        "d-none"
      );
      self.sessionContentList.forEach(function (tab) {
        tab.SessionRowList.forEach(function (row) {
          row.SessionCollection.forEach(function (session) {
            if (session.SessionId == sessionId) {
              if (session.SessionTypeDetails.TypeID == 3) {
                let headers = {
                  "content-type": "application/json",
                };
                let bodyData = {
                  meetingid: session.Zoom_Detail.id,
                  stream_url:
                    session.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.url,
                  stream_key:
                    session.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.streamKey,
                  page_url: session.ZoomRTMPMUX_detail.data.playbackUrl,
                };
                self.showLoader();
                axios
                  .post(APIs.EnableZoomRTMPStreaming, bodyData, {
                    headers: headers,
                  })
                  .then((response) => {
                    self.hideLoader();
                    console.log(response.data);
                    if (response.data.code == 1) {
                      db.collection(self.eventcollection)
                        .doc("SessionList")
                        .collection("Sessions")
                        .doc(sessionId)
                        .update({
                          ZoomRTMPEnable_Status: response.data,
                          ZoomRTMPStarted: true,
                        })
                        .then(function () {
                          //resolve(response.data);
                          $(
                            "#session_wrap_" +
                              sessionId +
                              " .on-demand-dropdown"
                          ).addClass("d-none");
                          self.showSnackbar(
                            "RTMP Streaming started successfully.",
                            "info",
                            "top"
                          );
                        })
                        .catch(function (error) {
                          //$(
                          //  "#session_wrap_" + sessionId + " .on-demand-dropdown"
                          //).addClass("d-none");
                          console.error(
                            "Error updating ZoomRTMPEnable_Status: ",
                            error
                          );
                          self.showSnackbar(
                            "Error on Start RTMP Streaming.",
                            "error",
                            "top"
                          );
                        });
                    } else {
                      console.log(response);
                      self.showSnackbar(
                        "Error on Start RTMP Streaming.",
                        "error",
                        "top"
                      );
                    }
                  })
                  .catch((error) => {
                    self.hideLoader();
                    console.log(error);
                    self.showSnackbar(
                      "Error on Start RTMP Streaming.",
                      "error",
                      "top"
                    );
                  });
              }
            }
          });
        });
      });
      if (e) {
        e.stopPropagation();
      }
    },
    StopRTMPStreaming(sessionId, e) {
      $("#session_wrap_" + sessionId + " .on-demand-dropdown").addClass(
        "d-none"
      );
      self.sessionContentList.forEach(function (tab) {
        tab.SessionRowList.forEach(function (row) {
          row.SessionCollection.forEach(function (session) {
            if (session.SessionId == sessionId) {
              if (session.SessionTypeDetails.TypeID == 3) {
                let headers = {
                  "content-type": "application/json",
                };
                let bodyData = {
                  meetingid: session.Zoom_Detail.id,
                };
                self.showLoader();
                axios
                  .post(APIs.DisableZoomRTMPStreaming, bodyData, {
                    headers: headers,
                  })
                  .then((response) => {
                    self.hideLoader();
                    console.log(response.data);
                    if (response.data.code == 1) {
                      db.collection(self.eventcollection)
                        .doc("SessionList")
                        .collection("Sessions")
                        .doc(sessionId)
                        .update({
                          ZoomRTMPEnable_Status: response.data,
                          ZoomRTMPStarted: false,
                        })
                        .then(function () {
                          //resolve(response.data);
                          $(
                            "#session_wrap_" +
                              sessionId +
                              " .on-demand-dropdown"
                          ).addClass("d-none");
                          self.showSnackbar(
                            "RTMP Streaming stopped successfully.",
                            "info",
                            "top"
                          );
                        })
                        .catch(function (error) {
                          //$(
                          //  "#session_wrap_" + sessionId + " .on-demand-dropdown"
                          //).addClass("d-none");
                          console.error(
                            "Error updating ZoomRTMPEnable_Status: ",
                            error
                          );
                          self.showSnackbar(
                            "Error on Stop RTMP Streaming.",
                            "error",
                            "top"
                          );
                        });
                    } else {
                      console.log(response);
                      self.showSnackbar(
                        "Error on Stop RTMP Streaming.",
                        "error",
                        "top"
                      );
                    }
                  })
                  .catch((error) => {
                    self.hideLoader();
                    console.log(error);
                    self.showSnackbar(
                      "Error on Stop RTMP Streaming.",
                      "error",
                      "top"
                    );
                  });
              }
            }
          });
        });
      });
      if (e) {
        e.stopPropagation();
      }
    },
    rtmpActions(action, sessionId) {
      let flag = true;
      if (action == 0) {
        self.rtmpDialog.key += 1;
        self.rtmpDialog.sessionId = "";
        self.rtmpDialog.session = null;
        self.rtmpDialog.rtmpOptions.sessionId = "";
        self.rtmpDialog.rtmpOptions.session = null;
        self.rtmpDialog.rtmpOptions.hasZoomLink = false;
        self.rtmpDialog.rtmpOptions.rtmpStartLink = false;
        self.rtmpDialog.rtmpOptions.rtmpStopLink = false;
        self.rtmpDialog.rtmpOptions.rtmpAudienceLink = false;
        self.rtmpDialog.rtmpOptions.viewersCount = 0;
        self.rtmpDialog.rtmpOptions.streamUrl = "";
        self.rtmpDialog.rtmpOptions.zoomUrl = "";
        if (sessionId) {
          let sessions = self.allSessions.filter((item) => {
            return item.SessionId == sessionId;
          });
          if (sessions.length > 0) {
            self.rtmpDialog.sessionId = sessionId;
            self.rtmpDialog.session = sessions[0];
            self.rtmpDialog.rtmpOptions.sessionId = sessionId;
            self.rtmpDialog.rtmpOptions.uid = self.userid;
            self.rtmpDialog.rtmpOptions.event_collectionName =
              self.eventcollection;
            if (sessions[0].IsHost) {
              self.rtmpDialog.rtmpOptions.title = "Welcome Session Host";
            } else if (sessions[0].IsSpeaker) {
              self.rtmpDialog.rtmpOptions.title = "Welcome Session Speaker";
            } else {
              self.rtmpDialog.rtmpOptions.title = "Welcome Session Attendee";
            }
            self.rtmpDialog.rtmpOptions.streamUrl =
              sessions[0].ZoomRTMPMUX_detail.data.playbackUrl;
            self.rtmpDialog.lastUpdateTimeStamp = new Date().getTime();

            self.initParticipantsListener(self.rtmpDialog.sessionId);
          } else {
            flag = false;
          }
        } else {
          flag = false;
        }
      }
      if (flag) {
        if (action == -1) {
          self.hideLoader();
          self.rtmpDialog.state = false;
          self.rtmpDialog.key += 1;
          //self.rtmpComponent.stopStreaming();
          if (ZoomRTMPParticipantsListener) {
            ZoomRTMPParticipantsListener();
            ZoomRTMPParticipantsListener = null;
          }
        } else if (action == 0) {
          $(".modal").modal("hide");
          self.hideLoader();
          self.rtmpDialog.state = true;
          setTimeout(() => {
            self.rtmpComponent.startStreaming();
          }, 100);
        } else if (action == 1) {
          //self.rtmpDialog.state = false;
          let session = self.rtmpDialog.session;
          if (session) {
            if (session.IsZoomRTMP) {
              if (session.IsZoomRTMP && session.IsHost) {
                window.open(session.Zoom_Detail.start_url, "_blank");
                self.postLeaderboardAction("SNVW");
              } else if (session.IsSpeaker) {
                if (!self.RestrictedZoomMeetingEnabled) {
                  var link =
                    session.Zoom_Detail.join_url +
                    "&uname=" +
                    self.firstName.trim() +
                    "%20" +
                    self.lastName.trim();
                  window.open(link, "_blank");
                  self.postLeaderboardAction("SNVW");
                } else {
                  bus.$emit("toggleLoader", true);
                  let headers = {
                    Authorization: "Bearer " + self.getSessionToken(),
                    "content-type": "application/json",
                  };
                  let requestData = {
                    email: self.email,
                    name: self.name,
                    first_name: self.firstName,
                    last_name: self.lastName,
                    meetingid: session.Zoom_Detail.id,
                    //address: "",
                    //phone: self.phone,
                    //industry: "",
                    //org: self.company,
                    //job_title: self.title,
                  };
                  axios
                    .post(APIs.AddAttendeesToZoom, requestData, {
                      headers: headers,
                    })
                    .then((response) => {
                      if (
                        response &&
                        response.data &&
                        response.data.status == 0 &&
                        response.data.data.id &&
                        response.data.data.join_url &&
                        response.data.data.join_url != ""
                      ) {
                        bus.$emit("toggleLoader", false);
                        window.open(response.data.data.join_url, "_blank");
                        self.postLeaderboardAction("SNVW");
                      } else {
                        bus.$emit("toggleLoader", false);
                        //vm.retryJoinInZoomPopup();
                      }
                    })
                    .catch((error) => {
                      bus.$emit("toggleLoader", false);
                      console.log(error);
                      //m.retryJoinInZoomPopup();
                    });
                }
              }
            }
          }
        } else if (action == 2) {
          self.rtmpDialog.rtmpOptions.startProcessing = true;
          self.StartRTMPStreaming(self.rtmpDialog.rtmpOptions.sessionId);
          setTimeout(() => {
            self.rtmpDialog.rtmpOptions.startProcessing = false;
          }, 2000);
        } else if (action == 3) {
          self.rtmpDialog.rtmpOptions.stopProcessing = true;
          self.StopRTMPStreaming(self.rtmpDialog.sessionId);
          setTimeout(() => {
            self.rtmpDialog.rtmpOptions.stopProcessing = false;
          }, 2000);
        } else if (action == 4) {
          self.rtmpDialog.state = false;
          self.GoForInternalPlayer(self.rtmpDialog.sessionId);
        }
      }
    },

    initParticipantsListener(sessionId) {
      if (ZoomRTMPParticipantsListener) {
        ZoomRTMPParticipantsListener();
        ZoomRTMPParticipantsListener = null;
      }
      if (!ZoomRTMPParticipantsListener) {
        ZoomRTMPParticipantsListener = db
          .collection(self.eventcollection)
          .doc("SessionList")
          .collection("Sessions")
          .doc(sessionId)
          .collection("Participances")
          .onSnapshot((querySnapshot) => {
            var viewersCount = 0;
            querySnapshot.forEach((doc) => {
              if (doc.data().IsActive) {
                viewersCount++;
              }
            });
            self.rtmpDialog.rtmpOptions.viewersCount = viewersCount;
          });
      }
      db.collection(self.eventcollection)
        .doc("UserVideoActivity")
        .collection("Session")
        .doc(sessionId)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let data = doc.data();
            self.rtmpDialog.rtmpOptions.chatEnabled = data.ChatEnabled
              ? data.ChatEnabled
              : false;
            self.rtmpDialog.rtmpOptions.qnaEnabled = data.QnAEnabled
              ? data.QnAEnabled
              : false;
            //self.rtmpDialog.rtmpOptions.attendeeEnabled = data.AttendeeEnabled
            //  ? data.AttendeeEnabled
            //  : false;
          }
        });
    },
    onStartSession(sessionId) {
      self.sessionContentList.forEach(function (tab) {
        tab.SessionRowList.forEach(function (row) {
          row.SessionCollection.forEach(function (session) {
            if (session.SessionId == sessionId) {
              if (session.SessionTypeDetails.TypeID == 1) {
                self.ShowBroadCastPg(
                  session.SessionId,
                  self.GlobalKeysData.IsVideoInNewTab,
                  "video",
                  self.eventId,
                  self.GlobalKeysData.IsOpenInternalPlayer
                );
              } else if (session.SessionTypeDetails.TypeID == 2) {
                self.ShowBroadCastPg(
                  session.SessionId,
                  self.GlobalKeysData.IsVideoInNewTab,
                  "video",
                  self.eventId,
                  self.GlobalKeysData.IsOpenInternalPlayer
                );
              } else if (
                session.SessionTypeDetails.TypeID == 3 ||
                session.SessionTypeDetails.TypeID == 5
              ) {
                self.goForGreenRoom(
                  self.GlobalKeysData.videoParamsEncryptURL,
                  self.GlobalKeysData.BroadcastStartURL,
                  self.GlobalKeysData.BroadcastViewURL,
                  self.GlobalKeysData.IsBroadcastInNewTab,
                  session.SessionId,
                  self.GlobalKeysData.ChannelPrefix,
                  self.GlobalKeysData.BroadcastID,
                  self.GlobalKeysData.BroadcastCertificate,
                  self.GlobalKeysData.BroadcastSpeakerApiUrl,
                  self.GlobalKeysData.BroadcastAttendeeApiUrl,
                  self.GlobalKeysData.BroadcastvalidityHours,
                  self.userid,
                  self.eventId,
                  "startbroadcast",
                  session.Name,
                  session.broadcastUrlForSession,
                  self.clientID,
                  session.IamInThesession,
                  self.GlobalKeysData.IsOpenInternalPlayer,
                  session.StreamingClient,
                  session.MappedHosts,
                  session.MappedSpeakers,
                  session.Zoom_Detail,
                  session.IsZoomRTMP,
                  session.ZoomRTMPMUX_detail,
                  session.InPersonURL
                );
              } else if (session.SessionTypeDetails.TypeID == 4) {
                self.goForlivestage(
                  session.SessionId,
                  session.SessionTypeDetails.RoundTableTopic.TopicId
                );
              }
            }
          });
        });
      });
    },
    getSpeakerSettings() {
      //--------get  setting---------------------------------------------------------------------------------
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      self.ShowMeetingButton = false;
      self.ShowFilter = false;
      self.ShowSendMessageButton = false;
      self.ShowSearch = false;
      var refSpeakerSettings = db
        .collection(obj.eventcollectionname)
        .doc("Settings")
        .collection("Speaker")
        .doc("SpeakerSettings");
      refSpeakerSettings.get().then(function (doc) {
        if (doc.exists) {
          self.ShowMeetingButton =
            doc.data().ShowMeetingButton == undefined
              ? false
              : doc.data().ShowMeetingButton;
          self.ShowSendMessageButton =
            doc.data().ShowSendMessageButton == undefined
              ? false
              : doc.data().ShowSendMessageButton;
          // self.ShowFilter =
          //   doc.data().ShowFilter == undefined ? false : doc.data().ShowFilter;
          // self.ShowSearch =
          //   doc.data().ShowSearch == undefined ? false : doc.data().ShowSearch;
        }
      });
      console.log(self.ShowMeetingButton);
    },
    OpenRequestMeeting() {
      if (document.getElementById("dvImgeHldText").innerText == "") {
        var AttendeeImgPath = document.getElementById("imgModalSpeakers").src;

        if (AttendeeImgPath != null && AttendeeImgPath != "") {
          document.getElementById("ReqAttendeeImage").src = AttendeeImgPath;
        }

        $("#ReqAttendeeImage").show();
        document.getElementById("ReqdivImgHldText").innerText = "";
        $("#ReqdivImgHldText").hide();
      } else {
        var Initials = document.getElementById("dvImgeHldText").innerText;
        $("#ReqAttendeeImage").attr("src", "");
        $("#ReqAttendeeImage").hide();
        document.getElementById("ReqdivImgHldText").innerHTML =
          "<h4>" + Initials + "</h4>";
        $("#ReqdivImgHldText").show();
      }
      document.getElementById("ReqAttendeeEmail").innerText =
        document.getElementById("spnSpkEmail").innerText;

      document.getElementById("ReqAttendeePhone").innerText =
        document.getElementById("spnSpkPhone").innerText;

      document.getElementById("ReqAttendeeName").innerText =
        document.getElementById("modalName").innerText;
      document.getElementById("ReqAttendeeNameh4").innerText =
        document.getElementById("ReqAttendeeName").innerText;
      document.getElementById("ReqAttendeeTitle").innerText =
        document.getElementById("modalTtile").innerText;
      document.getElementById("ReqAttendeeCompany").innerText =
        document.getElementById("modalCompany").innerText;

      document.getElementById("ReqAttendeeEmail").innerText =
        document.getElementById("modalEmail").innerText;
      document.getElementById("ReqAttendeePhone").innerText =
        document.getElementById("modalPhone").innerText;
      document.getElementById("ReqAttendeeWebsite").innerText =
        document.getElementById("modalWebsite").innerText;

      var hdnattendeeId = $("#hdnattendeeId").val();

      var ComponentClass = Vue.extend(RequestMeeting);
      var instance = new ComponentClass({
        propsData: { attendeeId: hdnattendeeId },
      });
      instance.$mount();
    },
    prepareMySession() {
      self.mySessions = [];
      //var obj = JSON.parse(window.localStorage.getItem("my-app"));
      //if (
      //  obj &&
      //  obj.eventcollectionname &&
      //  obj.user &&
      //  obj.user.length > 0 &&
      //  obj.user[0].id
      //) {
      //  db.collection(obj.eventcollectionname)
      //    .doc("AttendeeList")
      //    .collection("Attendees")
      //    .doc(obj.user[0].id)
      //    .collection("MappedSessions")
      //    .get()
      //    .then((querySnapshot) => {
      //      querySnapshot.forEach((doc) => {
      //        self.mySessions.push(doc.id);
      //      });
      //      self.mySessionsLoaded = true;
      //    });
      //}

      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientID,
          eventId: self.eventId,
        },
        data: {
          AttendeeId: self.userid,
        },
      };
      //self.showLoader();
      axios
        .post(APIs.MyAgenda, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          self.hideLoader();
          if (
            responseData &&
            responseData.data &&
            responseData.data.status == 0 &&
            responseData.data.sessions
          ) {
            responseData.data.sessions.map(function (item) {
              self.mySessions.push(item.SessionId);
            });
          }
          self.mySessionsLoaded = true;
        })
        .catch((error) => {
          debugger;
          self.hideLoader();
          console.log(error);
          self.mySessionsLoaded = true;
        });
    },
    prepareSessionTabData() {
      self.sessionTabList = [];
      self.speakerDetailsForPopup = [];
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      console.log("EventColName : " + obj.eventcollectionname);
      console.log("EventID : " + self.eventId);
      console.log("clientId : " + self.clientID);

      db.collection(obj.eventcollectionname)
        .doc("TrackList")
        .collection("Tracks")
        .get()
        .then((querySnapshotSpk) => {
          self.allTracks = [];
          querySnapshotSpk.forEach((doc) => {
            var trackId = doc.data().TrackId;
            var name = doc.data().Name;
            var colorCode = doc.data().ColorCode;
            self.allTracks.push({
              TrackId: trackId,
              Name: name,
              ColorCode: colorCode,
            });
          });
        });
      db.collection(obj.eventcollectionname)
        .doc("SpeakerList")
        .collection("Speakers")
        .get()
        .then((querySnapshotSpk) => {
          self.allSpeakers = [];
          querySnapshotSpk.forEach((doc) => {
            var profile = doc.data().Profile;
            profile = profile == undefined ? "" : profile;
            var speakerId = doc.data().SpeakerId;
            var hideInList = doc.data().HideInList
              ? doc.data().HideInList
              : false;
            self.allSpeakers.push({
              SpeakerId: speakerId,
              Profile: profile,
              HideInList: hideInList,
            });
          });

          var listRef = db
            .collection(obj.eventcollectionname) //"OA_UAT_C1591205467009E1591206650065")
            .doc("SessionList")
            .collection("Sessions")
            .where("IsPublished", "==", true);
          var dtt;

          listRef
            .orderBy("StartDate", "asc")
            .orderBy("EndDate", "asc")
            .get()
            .then((querySnapshot) => {
              var currentTime = parseInt(new Date().getTime() / 1000);
              querySnapshot.forEach((doc) => {
                // var fldte = "";
                let data = doc.data();
                let flag = true;
                if (self.trackId) {
                  flag = false;
                  if (data.Track && data.Track.TrackID) {
                    if (data.Track.TrackID == self.trackId) {
                      flag = true;
                    }
                  }
                }
                if (flag) {
                  var dateTabLabel;
                  if (doc.data().StartDate != undefined) {
                    dtt = new Date(doc.data().StartDate.seconds * 1000);
                    var dtYear = dtt.getFullYear();
                    var dtMonth = dtt.getMonth();
                    var dtDay = dtt.getDate();
                    dateTabLabel = dtt.toString().substring(0, 10);
                  } else {
                    dateTabLabel = "";
                  }
                  var sessionTab = self.sessionTabList.filter(function (value) {
                    return value.DateTabLabel == dateTabLabel;
                  });
                  var mappedHosts = [];
                  var mappedSpeakers = [];
                  if (sessionTab.length == 0) {
                    var tbObj = new Object();

                    tbObj.DateTabLabel = dateTabLabel; //display date tab format
                    tbObj.DateTabId =
                      "menu" +
                      tbObj.DateTabLabel.replace(" ", "").replace(" ", "");
                    tbObj.StartDate = new Date(dtYear, dtMonth, dtDay);

                    tbObj.StartTime = parseInt(
                      tbObj.StartDate.getTime() / 1000
                    );
                    tbObj.EndDate = new Date(dtYear, dtMonth, dtDay);
                    tbObj.EndDate.setDate(tbObj.EndDate.getDate() + 1);
                    tbObj.EndTime = parseInt(tbObj.EndDate.getTime() / 1000);
                    tbObj.CurrentClass = "";

                    self.sessionTabList.push(tbObj);

                    var sessionContentObj = new Object();
                    sessionContentObj.DateTabLabel = dateTabLabel;
                    sessionContentObj.DateTabId =
                      "menu" +
                      sessionContentObj.DateTabLabel.replace(" ", "").replace(
                        " ",
                        ""
                      );
                    sessionContentObj.CurrentClass = "";
                    sessionContentObj.SessionRowList = [];
                    self.sessionContentList.push(sessionContentObj);
                  }
                  var sessionContents = self.sessionContentList.filter(
                    function (value) {
                      return value.DateTabLabel == dateTabLabel;
                    }
                  );
                  //
                  if (sessionContents.length != 0) {
                    var sessionTabIndex = self.sessionContentList.indexOf(
                      sessionContents[0]
                    );
                    var filteredRows = self.sessionContentList[
                      sessionTabIndex
                    ].SessionRowList.filter(function (value) {
                      return value.StartTime == doc.data().StartDate.seconds;
                    });
                    if (filteredRows.length == 0) {
                      var objRow = new Object();
                      objRow.StartTime = doc.data().StartDate.seconds;
                      objRow.EndTime = doc.data().EndDate.seconds;
                      objRow.SessionCollection = [];
                      objRow.TrackCollection = [];
                      self.sessionContentList[
                        sessionTabIndex
                      ].SessionRowList.push(objRow);
                    }

                    filteredRows = self.sessionContentList[
                      sessionTabIndex
                    ].SessionRowList.filter(function (value) {
                      return value.StartTime == doc.data().StartDate.seconds;
                    });

                    //----------------check if the speaker of the session------------------------------------------------------------------

                    mappedHosts =
                      doc.data().MappedHosts != undefined
                        ? doc.data().MappedHosts
                        : [];
                    mappedSpeakers =
                      doc.data().MappedSpeakers != undefined
                        ? doc.data().MappedSpeakers
                        : [];
                    var filteredspkr = mappedSpeakers.filter(function (value) {
                      return self.userid == value.AttendeeId;
                    });
                    var IamInThesession = false;
                    var broadcastUrlForSession =
                      self.GlobalKeysData.BroadcastViewURL;
                    if (filteredspkr.length > 0) {
                      IamInThesession = true;
                      broadcastUrlForSession =
                        self.GlobalKeysData.BroadcastStartURL;
                    }

                    $.each(mappedHosts, function (index, value) {
                      var spkrs = self.allSpeakers.filter(function (valueSpkr) {
                        return value.AttendeeId == valueSpkr.SpeakerId;
                      });
                      if (spkrs.length > 0) {
                        value.Profile = spkrs[0].Profile;
                      }
                      var filteredList = self.allSpeakers.filter(function (
                        spkr
                      ) {
                        return value.AttendeeId == spkr.SpeakerId;
                      });
                      if (filteredList.length > 0) {
                        value.HideInList = filteredList[0].HideInList;
                      }
                    });
                    $.each(mappedSpeakers, function (index, value) {
                      var spkrs = self.allSpeakers.filter(function (valueSpkr) {
                        return value.AttendeeId == valueSpkr.SpeakerId;
                      });
                      if (spkrs.length > 0) {
                        value.Profile = spkrs[0].Profile;
                      }
                      self.speakerDetailsForPopup.push(value);
                      var filteredList = self.allSpeakers.filter(function (
                        spkr
                      ) {
                        return value.AttendeeId == spkr.SpeakerId;
                      });
                      if (filteredList.length > 0) {
                        value.HideInList = filteredList[0].HideInList;
                      }
                    });

                    mappedHosts.sort(function (a, b) {
                      let aName = a.Name.trim().toLowerCase();
                      let bName = b.Name.trim().toLowerCase();
                      if (aName < bName) {
                        return -1;
                      }
                      if (aName > bName) {
                        return 1;
                      }
                      return 0;
                    });
                    mappedSpeakers.sort(function (a, b) {
                      let aName = a.Name.trim().toLowerCase();
                      let bName = b.Name.trim().toLowerCase();
                      if (aName < bName) {
                        return -1;
                      }
                      if (aName > bName) {
                        return 1;
                      }
                      return 0;
                    });
                    //-----------------------------------------------------------------------------------

                    if (filteredRows.length != 0) {
                      // var currentRows = filteredRows[0];

                      var sessionIndex = self.sessionContentList[
                        sessionTabIndex
                      ].SessionRowList.indexOf(filteredRows[0]);

                      var objSession = new Object();
                      objSession.StartDate = doc.data().StartDate;
                      objSession.EndDate = doc.data().EndDate;
                      objSession.StartTime = doc.data().StartDate.seconds;
                      objSession.EndTime = doc.data().EndDate.seconds;
                      //

                      objSession.Name =
                        doc.data().Name != undefined ? doc.data().Name : "";

                      objSession.SessionId =
                        doc.data().SessionId != undefined
                          ? doc.data().SessionId
                          : "0";
                      objSession.DescriptionShort =
                        doc.data().DescriptionShort != undefined
                          ? doc.data().DescriptionShort
                          : "";

                      objSession.IsHost = false;
                      objSession.IsSpeaker = false;
                      objSession.HasBackStageAccess = false;

                      objSession.AllSpeakers =
                        doc.data().MappedSpeakers != undefined
                          ? doc.data().MappedSpeakers
                          : [];
                      objSession.AllSpeakers.forEach(function (item) {
                        if (item.AttendeeId == self.userid) {
                          objSession.IsSpeaker = true;
                        }
                        if (!item.ProfilePictureURL) {
                          item.ProfilePictureURL = "";
                        }
                        item.NameInitial = common.getInitials(item.Name);
                        var filteredList = self.allSpeakers.filter(function (
                          spkr
                        ) {
                          return item.AttendeeId == spkr.SpeakerId;
                        });
                        if (filteredList.length > 0) {
                          item.HideInList = filteredList[0].HideInList;
                        }
                      });
                      objSession.AllHosts =
                        doc.data().MappedHosts != undefined
                          ? doc.data().MappedHosts
                          : [];
                      objSession.AllCoHosts = doc.data().MappedCoHost
                        ? [doc.data().MappedCoHost]
                        : [];
                      //let flag = false;
                      objSession.AllHosts.forEach(function (item) {
                        if (item.AttendeeId == self.userid) {
                          objSession.IsHost = true;
                        }
                        if (!item.ProfilePictureURL) {
                          item.ProfilePictureURL = "";
                        }
                        item.NameInitial = common.getInitials(item.Name);
                        var filteredList = self.allSpeakers.filter(function (
                          spkr
                        ) {
                          return item.AttendeeId == spkr.SpeakerId;
                        });
                        if (filteredList.length > 0) {
                          item.HideInList = filteredList[0].HideInList;
                        }
                      });
                      objSession.AllCoHosts.forEach(function (item) {
                        if (item.AttendeeId == self.userid) {
                          objSession.IsHost = true;
                        }
                        if (!item.ProfilePictureURL) {
                          item.ProfilePictureURL = "";
                        }
                        item.NameInitial = common.getInitials(item.Name);
                        var filteredList = self.allSpeakers.filter(function (
                          spkr
                        ) {
                          return item.AttendeeId == spkr.SpeakerId;
                        });
                        if (filteredList.length > 0) {
                          item.HideInList = filteredList[0].HideInList;
                        }
                      });

                      objSession.IamInThesession = IamInThesession;
                      objSession.broadcastUrlForSession =
                        broadcastUrlForSession;

                      objSession.StreamingClient = doc.data().StreamingClient;
                      objSession.Zoom_Detail = doc.data().Zoom_Detail;
                      objSession.IsZoomRTMP = doc.data().IsZoomRTMP
                        ? doc.data().IsZoomRTMP
                        : false;
                      objSession.ZoomMeetingStarted = doc.data().MeetingStarted
                        ? doc.data().MeetingStarted
                        : false;
                      objSession.ZoomRTMPMUX_detail =
                        doc.data().ZoomRTMPMUX_detail;
                      objSession.ZoomRTMPEnable_Status =
                        doc.data().ZoomRTMPEnable_Status;
                      objSession.ZoomRTMPStarted = doc.data().ZoomRTMPStarted
                        ? doc.data().ZoomRTMPStarted
                        : false;
                      objSession.MappedHosts = doc.data().MappedHosts;
                      objSession.SessionTypeDetails =
                        doc.data().SessionTypeDetails;
                      if (
                        objSession.SessionTypeDetails
                          .ConvertToOnDemandVideoOnSessionEnd == undefined
                      ) {
                        objSession.SessionTypeDetails.ConvertToOnDemandVideoOnSessionEnd = false;
                      }

                      objSession.InPersonLabel = "In-Person";
                      objSession.InPersonIcon =
                        "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2Fin-person.svg?alt=media";
                      objSession.InPersonURL = "";
                      if (doc.data().SessionTypeDetails.TypeID == 5) {
                        if (
                          doc.data().SessionTypeDetails.InPersonLabel &&
                          doc.data().SessionTypeDetails.InPersonLabel.length > 0
                        ) {
                          objSession.InPersonLabel =
                            doc.data().SessionTypeDetails.InPersonLabel;
                        }
                        if (
                          doc.data().SessionTypeDetails.InPersonIcon &&
                          doc.data().SessionTypeDetails.InPersonIcon.length > 0
                        ) {
                          objSession.InPersonIcon =
                            doc.data().SessionTypeDetails.InPersonIcon;
                        }
                        if (
                          doc.data().SessionTypeDetails.InPersonURL &&
                          doc.data().SessionTypeDetails.InPersonURL.length > 0
                        ) {
                          objSession.InPersonURL =
                            doc.data().SessionTypeDetails.InPersonURL;
                        }
                      }
                      objSession.Track = doc.data().Track;
                      if (!objSession.Track) {
                        objSession.Track = { TrackID: "", TrackName: "" };
                      }
                      for (var i = 0; i < mappedHosts.length; i++) {
                        if (!mappedHosts[i].ProfilePictureURL) {
                          mappedHosts[i].ProfilePictureURL = "";
                        }
                        mappedHosts[i].NameInitial = common.getInitials(
                          mappedHosts[i].Name
                        );
                      }
                      for (var j = 0; j < mappedSpeakers.length; j++) {
                        if (!mappedSpeakers[j].ProfilePictureURL) {
                          mappedSpeakers[j].ProfilePictureURL = "";
                        }
                        mappedSpeakers[j].NameInitial = common.getInitials(
                          mappedSpeakers[j].Name
                        );
                      }

                      objSession.MappedSpeakers = mappedSpeakers.slice(
                        0,
                        self.spkrLimit
                      );
                      if (mappedSpeakers.length > self.spkrLimit + 1) {
                        objSession.ShowPlush = true;
                        objSession.Plushcount =
                          mappedSpeakers.length - self.spkrLimit;
                        objSession.MappedSpeakers = mappedSpeakers.slice(
                          0,
                          self.spkrLimit
                        );
                      } else {
                        objSession.ShowPlush = false;
                        objSession.MappedSpeakers = mappedSpeakers.slice(
                          0,
                          self.spkrLimit + 1
                        );
                      }

                      objSession.StartTimeLabel = self.getFormattedTime(
                        doc.data().StartDate.seconds
                      );
                      objSession.EndTimeLabel = self.getFormattedTime(
                        doc.data().EndDate.seconds
                      );
                      self.sessionContentList[sessionTabIndex].SessionRowList[
                        sessionIndex
                      ].SessionCollection.push(objSession);
                      objSession.DateTabLabel = dateTabLabel;

                      objSession.IsLive = false;
                      objSession.IsUpcoming = false;
                      objSession.ShowOnDemandVideo = false;
                      objSession.LinkClass =
                        "upcoming-status new-btn-design-disabled";
                      objSession.StatusDisplayText =
                        self.$t("livestage.upcoming");
                      objSession.StatusClass = "upcoming-session";

                      var uSpkrs1 = objSession.AllSpeakers.filter(function (
                        value
                      ) {
                        return value.AttendeeId == self.userid;
                      });
                      if (currentTime < objSession.StartTime) {
                        if (
                          uSpkrs1.length > 0 &&
                          objSession.SessionTypeDetails.TypeID ==
                            self.GlobalKeysData.LivePanelTypeID
                        ) {
                          objSession.IsLive = true;
                          objSession.LinkClass = "ongoing-status";
                          objSession.HasBackStageAccess = true;
                        } else {
                          objSession.LinkClass =
                            "upcoming-status new-btn-design-disabled";
                        }
                        objSession.StatusDisplayText =
                          self.$t("livestage.upcoming");
                        objSession.StatusClass = "upcoming-session";
                        objSession.IsUpcoming = true;
                      } else if (
                        currentTime > objSession.StartTime &&
                        currentTime < objSession.EndTime
                      ) {
                        if (
                          !objSession.IsZoomRTMP ||
                          objSession.IsHost ||
                          objSession.IsSpeaker
                        ) {
                          objSession.IsLive = true;
                          objSession.StatusDisplayText =
                            self.$t("livestage.live");
                          objSession.StatusClass = "active-session";
                          objSession.LinkClass = "ongoing-status";
                        } else {
                          if (
                            objSession.IsZoomRTMP &&
                            objSession.ZoomRTMPStarted
                          ) {
                            objSession.IsLive = true;
                            objSession.LinkClass = "ongoing-status";
                          }
                          objSession.StatusDisplayText =
                            self.$t("livestage.live");
                          objSession.StatusClass = "active-session";
                        }
                      } else if (currentTime > objSession.EndTime) {
                        if (
                          objSession.SessionTypeDetails.TypeID ==
                          self.GlobalKeysData.OnDemandTypeID
                        ) {
                          objSession.IsLive = true;
                          objSession.StatusDisplayText = self.$t(
                            "livestage.sessionended"
                          );
                          objSession.StatusClass = "finish-session";
                          objSession.LinkClass = "ongoing-status";
                        } else {
                          objSession.StatusDisplayText = self.$t(
                            "livestage.sessionended"
                          );
                          objSession.StatusClass = "finish-session";
                          objSession.LinkClass =
                            "finish-status new-btn-design-disabled";
                        }
                      }
                      self.allSessions.push(objSession);
                      //-------------------------------session row ends----------------------------------------------------------------------------
                      var objTrack = new Object();
                      if (doc.data().Track != undefined) {
                        if (doc.data().Track.TrackName != undefined) {
                          objTrack.TrackName = doc.data().Track.TrackName;
                          objTrack.TrackId = doc.data().Track.TrackID;
                        }
                      }
                      self.sessionContentList[sessionTabIndex].SessionRowList[
                        sessionIndex
                      ].TrackCollection.push(objTrack);
                    }
                  }
                  var isUpcoming = false;
                  var uSpkrs = objSession.AllSpeakers.filter(function (value) {
                    return value.AttendeeId == self.userid;
                  });
                  //if (currentTime < objSession.StartTime) {
                  //  if (
                  //    uSpkrs.length > 0 &&
                  //    objSession.SessionTypeDetails.TypeID ==
                  //      self.GlobalKeysData.LivePanelTypeID
                  //  ) {
                  //    objSession.IsLive = true;
                  //    objSession.LinkClass = "ongoing-status";
                  //  } else {
                  //    objSession.LinkClass =
                  //      "upcoming-status new-btn-design-disabled";
                  //  }
                  //  objSession.StatusDisplayText = self.$t("livestage.upcoming");
                  //  objSession.StatusClass = "upcoming-session";
                  //  isUpcoming = true;
                  //} else if (
                  //  currentTime > objSession.StartTime &&
                  //  currentTime < objSession.EndTime
                  //) {
                  //  if (!objSession.IsZoomRTMP || uSpkrs.length > 0) {
                  //    objSession.IsLive = true;
                  //    objSession.StatusDisplayText = self.$t("livestage.live");
                  //    objSession.StatusClass = "active-session";
                  //    objSession.LinkClass = "ongoing-status";
                  //  } else {
                  //    if (objSession.IsZoomRTMP && objSession.ZoomRTMPStarted) {
                  //      objSession.IsLive = true;
                  //      objSession.StatusDisplayText = self.$t("livestage.live");
                  //      objSession.StatusClass = "active-session";
                  //      objSession.LinkClass = "ongoing-status";
                  //    }
                  //  }
                  //} else if (currentTime > objSession.EndTime) {
                  //  if (
                  //    objSession.SessionTypeDetails.TypeID ==
                  //    self.GlobalKeysData.OnDemandTypeID
                  //  ) {
                  //    objSession.IsLive = true;
                  //    objSession.StatusDisplayText = self.$t(
                  //      "livestage.sessionended"
                  //    );
                  //    objSession.StatusClass = "finish-session";
                  //    objSession.LinkClass = "ongoing-status";
                  //  } else {
                  //    objSession.StatusDisplayText = self.$t(
                  //      "livestage.sessionended"
                  //    );
                  //    objSession.StatusClass = "finish-session";
                  //    objSession.LinkClass =
                  //      "finish-status new-btn-design-disabled";
                  //  }
                  //}

                  //sessionListForPopup data start -------------------------
                  //if (doc.data().SessionId == "199000") {
                  //}

                  var objSessionPopup = new Object();
                  objSessionPopup.SessionID = doc.data().SessionId;
                  objSessionPopup.SessionTypeDetails =
                    doc.data().SessionTypeDetails;
                  if (
                    objSessionPopup.SessionTypeDetails &&
                    objSessionPopup.SessionTypeDetails.TypeID
                  ) {
                    objSessionPopup.SessionTypeID =
                      doc.data().SessionTypeDetails.TypeID;
                  } else {
                    objSessionPopup.SessionTypeID = 0;
                  }
                  if (objSessionPopup.SessionTypeID == 4) {
                    objSessionPopup.TopicId =
                      doc.data().SessionTypeDetails.RoundTableTopic.TopicId;
                  } else {
                    objSessionPopup.TopicId = "";
                  }
                  objSessionPopup.Location = doc.data().Location.LocationName;
                  objSessionPopup.Title = doc.data().Name;
                  objSessionPopup.DescriptionShort =
                    doc.data().DescriptionShort;
                  objSessionPopup.StartTimeLabel = self.getFormattedDateTime(
                    doc.data().StartDate.seconds
                  );
                  objSessionPopup.EndTimeLabel = self.getFormattedDateTime(
                    doc.data().EndDate.seconds
                  );
                  objSessionPopup.StartTime = doc.data().StartDate.seconds;
                  objSessionPopup.EndTime = doc.data().EndDate.seconds;
                  objSessionPopup.Description = doc.data().Description;
                  objSessionPopup.MappedHosts = mappedHosts;
                  objSessionPopup.MappedSpeakers = mappedSpeakers;
                  var activeSpeakers = mappedSpeakers.filter(function (item) {
                    return !item.HideInList;
                  });
                  objSessionPopup.SpeakerLength = activeSpeakers.length;
                  objSessionPopup.IsUpcoming = isUpcoming;
                  objSessionPopup.Resources =
                    doc.data().Resources == undefined
                      ? []
                      : doc.data().Resources;

                  objSessionPopup.InPersonLabel = "In-Person";
                  objSessionPopup.InPersonIcon =
                    "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2Fin-person.svg?alt=media";
                  objSessionPopup.InPersonURL = "";
                  if (doc.data().SessionTypeDetails.TypeID == 5) {
                    if (
                      doc.data().SessionTypeDetails.InPersonLabel &&
                      doc.data().SessionTypeDetails.InPersonLabel.length > 0
                    ) {
                      objSessionPopup.InPersonLabel =
                        doc.data().SessionTypeDetails.InPersonLabel;
                    }
                    if (
                      doc.data().SessionTypeDetails.InPersonIcon &&
                      doc.data().SessionTypeDetails.InPersonIcon.length > 0
                    ) {
                      objSessionPopup.InPersonIcon =
                        doc.data().SessionTypeDetails.InPersonIcon;
                    }
                    if (
                      doc.data().SessionTypeDetails.InPersonURL &&
                      doc.data().SessionTypeDetails.InPersonURL.length > 0
                    ) {
                      objSessionPopup.InPersonURL =
                        doc.data().SessionTypeDetails.InPersonURL;
                    }
                  }

                  if (currentTime < objSessionPopup.StartTime) {
                    if (
                      uSpkrs.length > 0 &&
                      objSessionPopup.SessionTypeDetails.TypeID ==
                        self.GlobalKeysData.LivePanelTypeID
                    ) {
                      objSessionPopup.IsLive = true;
                      objSessionPopup.LinkClass = "ongoing-status";
                      objSessionPopup.HasBackStageAccess = true;
                    } else {
                      objSessionPopup.LinkClass =
                        "upcoming-status new-btn-design-disabled";
                    }
                    objSessionPopup.StatusDisplayText =
                      self.$t("livestage.upcoming");
                    objSessionPopup.StatusClass = "upcoming-session";
                    isUpcoming = true;
                  } else if (
                    currentTime > objSessionPopup.StartTime &&
                    currentTime < objSessionPopup.EndTime
                  ) {
                    objSessionPopup.IsLive = true;
                    objSessionPopup.StatusDisplayText =
                      self.$t("livestage.live");
                    objSessionPopup.StatusClass = "active-session";
                    objSessionPopup.LinkClass = "ongoing-status";
                  } else if (currentTime > objSessionPopup.EndTime) {
                    if (
                      objSessionPopup.SessionTypeDetails.TypeID ==
                      self.GlobalKeysData.OnDemandTypeID
                    ) {
                      objSessionPopup.IsLive = true;
                      objSessionPopup.StatusDisplayText = self.$t(
                        "livestage.sessionended"
                      );
                      objSessionPopup.StatusClass = "finish-session";
                      objSessionPopup.LinkClass = "ongoing-status";
                    } else {
                      objSessionPopup.StatusDisplayText = self.$t(
                        "livestage.sessionended"
                      );
                      objSessionPopup.StatusClass = "finish-session";
                      objSessionPopup.LinkClass =
                        "finish-status new-btn-design-disabled";
                    }
                  }
                  self.sessionListForPopup.push(objSessionPopup);
                }
              });

              var tabSelected = false;
              var tIndx = 0;
              var todaysTab = self.sessionTabList.filter(function (tab) {
                return (
                  currentTime * 1000 >= tab.StartTime &&
                  currentTime < tab.EndTime
                );
              });
              if (todaysTab.length > 0) {
                for (tIndx = 0; tIndx < self.sessionTabList.length; tIndx++) {
                  if (!tabSelected) {
                    if (
                      currentTime * 1000 >=
                        self.sessionTabList[tIndx].StartTime &&
                      currentTime * 1000 < self.sessionTabList[tIndx].EndTime
                    ) {
                      self.selectedDateValue =
                        self.sessionTabList[tIndx].DateTabId;
                      self.sessionTabList[tIndx].CurrentClass = "active";
                      self.sessionContentList[tIndx].CurrentClass = "active";
                      tabSelected = true;
                      break;
                    }
                  }
                }
              }

              if (!tabSelected) {
                var upCommingTab = self.sessionTabList.filter(function (tab) {
                  return currentTime * 1000 < tab.StartTime;
                });
                if (upCommingTab.length > 0) {
                  for (tIndx = 0; tIndx < self.sessionTabList.length; tIndx++) {
                    if (!tabSelected) {
                      if (
                        currentTime * 1000 <
                        self.sessionTabList[tIndx].StartTime
                      ) {
                        self.selectedDateValue =
                          self.sessionTabList[tIndx].DateTabId;
                        self.sessionTabList[tIndx].CurrentClass = "active";
                        self.sessionContentList[tIndx].CurrentClass = "active";
                        tabSelected = true;
                        break;
                      }
                    }
                  }
                }
              }

              if (!tabSelected) {
                var finishedTab = self.sessionTabList.filter(function (tab) {
                  return currentTime * 1000 > tab.StartTime;
                });
                if (finishedTab.length > 0) {
                  for (
                    tIndx = self.sessionTabList.length - 1;
                    tIndx >= 0;
                    tIndx--
                  ) {
                    if (!tabSelected) {
                      if (
                        currentTime * 1000 >
                        self.sessionTabList[tIndx].StartTime
                      ) {
                        self.selectedDateValue =
                          self.sessionTabList[tIndx].DateTabId;
                        self.sessionTabList[tIndx].CurrentClass = "active";
                        self.sessionContentList[tIndx].CurrentClass = "active";
                        tabSelected = true;
                        break;
                      }
                    }
                  }
                }
              }

              //-------------------------------------------------------
              for (
                var tIndex = 0;
                tIndex < self.sessionContentList.length;
                tIndex++
              ) {
                for (
                  var rIndex = 0;
                  rIndex <
                  self.sessionContentList[tIndex].SessionRowList.length;
                  rIndex++
                ) {
                  var rowSessCnt =
                    self.sessionContentList[tIndex].SessionRowList[rIndex]
                      .SessionCollection.length;

                  self.sessionContentList[tIndex].SessionRowList[
                    rIndex
                  ].RowSessionCount = rowSessCnt;

                  self.sessionContentList[tIndex].SessionRowList[
                    rIndex
                  ].StartTimeLabel =
                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].SessionCollection[0].StartTimeLabel;
                  self.sessionContentList[tIndex].SessionRowList[
                    rIndex
                  ].EndTimeLabel =
                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].SessionCollection[0].EndTimeLabel;

                  if (rowSessCnt == 1) {
                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].SessionClass = "one-session";

                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].TrackClass = "one-track";
                  } else if (rowSessCnt == 2) {
                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].SessionClass = "two-session";
                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].TrackClass = "two-track";
                  } else if (rowSessCnt == 3) {
                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].SessionClass = "three-session";
                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].TrackClass = "three-track";
                  }
                }
              }
              self.sessionsLoaded = true;
              //if (
              //  self.AgendaFilterOption >= 0 &&
              //  self.selectedAgendaType == -1
              //) {
              //  self.selectedAgendaType = 0;
              //  self.setupCurrentTabs();
              //}
              //console.log(self.sessionTabList);
              self.selectedTabSessions = self.sessionContentList.filter(
                function () {
                  return true;
                }
              );
              console.log(self.sessionContentList);

              setTimeout(() => {
                $('[data-toggle="tooltip"]').tooltip();
              }, 1000);
            })
            .catch((error) => {
              console.trace(error);
            });
        })
        .catch(function (error) {
          console.error("Error : ", error);
        });
      $("#dvMainTabContent div:first").addClass("active");
    },
    updateSessionStatus() {
      ////debugger;

      var currentTime = parseInt(new Date().getTime() / 1000);
      self.selectedTabSessions.forEach((doc) => {
        doc.SessionRowList.forEach((sessionRow) => {
          sessionRow.SessionCollection.forEach((objSession) => {
            var mappedSpeakers = objSession.AllSpeakers;
            objSession.HasBackStageAccess = false;
            var uSpkrs = mappedSpeakers.filter(function (value) {
              return value.AttendeeId == self.userid;
            });
            if (currentTime < objSession.StartTime) {
              if (
                uSpkrs.length > 0 &&
                objSession.SessionTypeDetails.TypeID ==
                  self.GlobalKeysData.LivePanelTypeID
              ) {
                objSession.IsLive = true;
                objSession.LinkClass = "ongoing-status";
                objSession.HasBackStageAccess = true;
              } else {
                objSession.LinkClass =
                  "upcoming-status new-btn-design-disabled";
              }
              objSession.StatusDisplayText = self.$t("livestage.upcoming");
              objSession.StatusClass = "upcoming-session";
            } else if (
              currentTime > objSession.StartTime &&
              currentTime < objSession.EndTime
            ) {
              if (
                self.IsZoomRTMPOptionsEnabled &&
                objSession.IsZoomRTMP &&
                !objSession.ZoomRTMPListener
              ) {
                self.ZoomRTMPStatusListener(objSession);
              }
              if (
                !objSession.IsZoomRTMP ||
                objSession.IsHost ||
                objSession.IsSpeaker
              ) {
                objSession.IsLive = true;
                objSession.StatusDisplayText = self.$t("livestage.live");
                objSession.StatusClass = "active-session";
                objSession.LinkClass = "ongoing-status";
              } else {
                if (objSession.ZoomRTMPStarted) {
                  objSession.IsLive = true;
                  objSession.LinkClass = "ongoing-status";
                } else {
                  objSession.IsLive = false;
                  objSession.LinkClass =
                    "upcoming-status new-btn-design-disabled";
                }
                objSession.StatusClass = "active-session";
                objSession.StatusDisplayText = self.$t("livestage.live");
              }
            } else if (currentTime > objSession.EndTime) {
              if (
                objSession.SessionTypeDetails.TypeID ==
                  self.GlobalKeysData.LivePanelTypeID &&
                objSession.IsLive &&
                objSession.IsZoomRTMP
              ) {
                if (objSession.ZoomRTMPListener) {
                  objSession.ZoomRTMPListener();
                  objSession.ZoomRTMPListener = null;
                }
              }
              if (
                objSession.SessionTypeDetails.TypeID ==
                self.GlobalKeysData.OnDemandTypeID
              ) {
                objSession.IsLive = true;
                objSession.StatusDisplayText = self.$t(
                  "livestage.sessionended"
                );
                objSession.StatusClass = "finish-session";
                objSession.LinkClass = "ongoing-status";
              } else {
                if (
                  objSession.SessionTypeDetails
                    .ConvertToOnDemandVideoOnSessionEnd &&
                  objSession.SessionTypeDetails.TypeID ==
                    self.GlobalKeysData.LivePanelTypeID &&
                  objSession.LinkClass == "ongoing-status"
                ) {
                  self.tryConvertLivePanelToOnDemandVideo(objSession.SessionId);
                }
                objSession.IsLive = false;
                objSession.StatusDisplayText = self.$t(
                  "livestage.sessionended"
                );
                objSession.StatusClass = "finish-session";
                objSession.LinkClass = "finish-status new-btn-design-disabled";
              }
            }
          });
        });
      });
      self.selectedTabSessions = self.selectedTabSessions.filter(function () {
        return true;
      });

      //self.sessionListForPopup.forEach((objSession) => {
      //  var mappedSpeakers = objSession.AllSpeakers;
      //  var uSpkrs = mappedSpeakers.filter(function (value) {
      //    return value.AttendeeId == self.userid;
      //  });
      //  if (currentTime < objSession.StartTime) {
      //    if (
      //      uSpkrs.length > 0 &&
      //      objSession.SessionTypeDetails.TypeID ==
      //        self.GlobalKeysData.LivePanelTypeID
      //    ) {
      //      objSession.IsLive = true;
      //      objSession.LinkClass = "ongoing-status";
      //    } else {
      //      objSession.LinkClass = "upcoming-status";
      //    }
      //    objSession.StatusDisplayText = self.$t("livestage.upcoming");
      //    objSession.StatusClass = "upcoming-session";
      //  } else if (
      //    currentTime > objSession.StartTime &&
      //    currentTime < objSession.EndTime
      //  ) {
      //    objSession.IsLive = true;
      //    objSession.StatusDisplayText = self.$t("livestage.live");
      //    objSession.StatusClass = "active-session";
      //    objSession.LinkClass = "ongoing-status";
      //  } else if (currentTime > objSession.EndTime) {
      //    if (
      //      objSession.SessionTypeDetails.TypeID ==
      //      self.GlobalKeysData.OnDemandTypeID
      //    ) {
      //      objSession.IsLive = true;
      //      objSession.StatusDisplayText = self.$t("livestage.sessionended");
      //      objSession.StatusClass = "finish-session";
      //      objSession.LinkClass = "ongoing-status";
      //    } else {
      //      objSession.StatusDisplayText = self.$t("livestage.sessionended");
      //      objSession.StatusClass = "finish-session";
      //      objSession.LinkClass = "finish-status";
      //    }
      //  }
      //});
    },
    ZoomRTMPStatusListener(objSession) {
      debugger;
      if (!objSession.ZoomRTMPListener) {
        objSession.ZoomRTMPListener = db
          .collection(self.eventcollection)
          .doc("SessionList")
          .collection("Sessions")
          .doc(objSession.SessionId)
          .onSnapshot((doc) => {
            var data = doc.data();
            objSession.ZoomRTMPStarted = data.ZoomRTMPStarted
              ? data.ZoomRTMPStarted
              : false;
            objSession.ZoomMeetingStarted = data.MeetingStarted
              ? data.MeetingStarted
              : false;
            //alert(objSession.ZoomRTMPStarted);
            //if (!objSession.ZoomRTMPStarted) {
            //  objSession.IsLive = false;

            //  objSession.LinkClass = "upcoming-status new-btn-design-disabled";
            //  objSession.StatusDisplayText = self.$t("livestage.upcoming");
            //  objSession.StatusClass = "upcoming-session";
            //}
            if (objSession.SessionId == self.rtmpDialog.sessionId) {
              self.rtmpDialog.session = objSession;
              self.rtmpDialog.lastUpdateTimeStamp = new Date().getTime();
            }
          });
      }
    },
    tryConvertLivePanelToOnDemandVideo(sessionId) {
      let channelName =
        "OAUAT_" + self.eventId.substring("1") + "_" + sessionId;
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientID,
          eventId: self.eventId,
        },
        data: {
          recEventId: self.eventId.substring("1"),
          sessionId: sessionId,
          channelId: channelName,
        },
      };
      axios
        .post(APIs.LivePanelToOnDemandVideo, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          console.log(responseData);
          if (responseData && responseData.data.status == 0) {
            let objSessions = self.allSessions.filter(function (item) {
              return item.SessionId == sessionId;
            });
            if (objSessions.length > 0) {
              objSessions[0].SessionTypeDetails.TypeID = 1;
              objSessions[0].SessionTypeDetails.TypeName = "On Demand";
              //objSessions[0].SessionTypeDetails.VideoURL =
              //  responseData.data.msg;
              objSessions[0].IsLive = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setFirebaseAppsettings: function () {
      //var obj = JSON.parse(window.localStorage.getItem("my-app"));

      var docRef = db.collection("OA_UAT").doc("OnAirAppSettings");

      docRef.get().then(function (doc) {
        if (doc.exists) {
          self.GlobalKeysData.BroadcastID = doc.data().AppIDRTC;
          self.GlobalKeysData.BroadcastCertificate = doc.data().CertificateRTC;
          self.GlobalKeysData.BroadcastSpeakerApiUrl =
            doc.data().SpeakerTokenURL;
          self.GlobalKeysData.BroadcastAttendeeApiUrl =
            doc.data().AttendeeTokenURL;
          self.GlobalKeysData.BroadcastStartURL = doc.data().BroadcastBaseURL;
          self.GlobalKeysData.BroadcastViewURL = doc.data().AudienceBaseURL;
          self.GlobalKeysData.BroadcastvalidityHours =
            doc.data().TokenValidityHours;
          self.GlobalKeysData.ChannelPrefix = doc.data().ChannelPrefix;
          self.GlobalKeysData.videoParamsEncryptURL = doc.data().EncryptionURL;
        }
      });
    },
    CloseModal: function () {
      $("#modalOpenBroadcast").modal("hide");
      $("#iframeBroadcast").attr("src", "");
      $("#modalOpenBroadcast").removeClass("minimize");
      $("#modalOpenBroadcast").removeClass("maximize-window");
      $(".modal-backdrop").hide();
    },
    retryJoinInZoomPopup() {
      $("#RetryJoinInZoom").modal(
        {
          backdrop: "static",
        },
        "show"
      );
    },
    cancelRetryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
    },
    retryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
      if (self.tempSession) {
        self.goForGreenRoom(
          self.tempSession.videoParamsEncryptURL,
          self.tempSession.BroadcastStartURL,
          self.tempSession.BroadcastViewURL,
          self.tempSession.IsBroadcastInNewTab,
          self.tempSession.sessionID,
          self.tempSession.ChannelPrefix,
          self.tempSession.BroadcastID,
          self.tempSession.BroadcastCertificate,
          self.tempSession.BroadcastSpeakerApiUrl,
          self.tempSession.BroadcastAttendeeApiUrl,
          self.tempSession.BroadcastvalidityHours,
          self.tempSession.UserID,
          self.tempSession.eventID,
          self.tempSession.BroadCastType,
          self.tempSession.SessionTitle,
          self.tempSession.BroadcastURL,
          self.tempSession.clientID,
          self.tempSession.IamInThesession,
          self.tempSession.IsOpenInternalPlayer,
          self.tempSession.StreamingClient,
          self.tempSession.MappedHost,
          self.tempSession.MappedSpeakers,
          self.tempSession.ZoomDetails,
          self.tempSession.IsZoomRTMP,
          self.tempSession.ZoomRTMPMUX_detail,
          self.tempSession.externalLink,
          self.tempSession.interactWithAudience
        );
      }
    },
    goForGreenRoom: function (
      videoParamsEncryptURL,
      BroadcastStartURL,
      BroadcastViewURL,
      IsBroadcastInNewTab,
      sessionID,
      ChannelPrefix,
      BroadcastID,
      BroadcastCertificate,
      BroadcastSpeakerApiUrl,
      BroadcastAttendeeApiUrl,
      BroadcastvalidityHours,
      UserID,
      eventID,
      BroadCastType,
      SessionTitle,
      BroadcastURL,
      clientID,
      IamInThesession,
      IsOpenInternalPlayer,
      StreamingClient,
      MappedHost,
      MappedSpeakers,
      ZoomDetails,
      IsZoomRTMP,
      ZoomRTMPMUX_detail,
      externalLink,
      interactWithAudience
    ) {
      debugger;
      if (StreamingClient == "Zoom") {
        self.tempSession = {
          videoParamsEncryptURL: videoParamsEncryptURL,
          BroadcastStartURL: BroadcastStartURL,
          BroadcastViewURL: BroadcastViewURL,
          IsBroadcastInNewTab: IsBroadcastInNewTab,
          sessionID: sessionID,
          ChannelPrefix: ChannelPrefix,
          BroadcastID: BroadcastID,
          BroadcastCertificate: BroadcastCertificate,
          BroadcastSpeakerApiUrl: BroadcastSpeakerApiUrl,
          BroadcastAttendeeApiUrl: BroadcastAttendeeApiUrl,
          BroadcastvalidityHours: BroadcastvalidityHours,
          UserID: UserID,
          eventID: eventID,
          BroadCastType: BroadCastType,
          SessionTitle: SessionTitle,
          BroadcastURL: BroadcastURL,
          clientID: clientID,
          IamInThesession: IamInThesession,
          IsOpenInternalPlayer: IsOpenInternalPlayer,
          StreamingClient: StreamingClient,
          MappedHost: MappedHost,
          MappedSpeakers: MappedSpeakers,
          ZoomDetails: ZoomDetails,
          IsZoomRTMP: IsZoomRTMP,
          ZoomRTMPMUX_detail: ZoomRTMPMUX_detail,
          externalLink: externalLink,
          interactWithAudience: interactWithAudience,
        };
        var hostList = [];
        var speakerList = [];

        MappedHost.filter(function (value) {
          hostList.push(value.AttendeeId);
        });

        MappedSpeakers.filter(function (value) {
          speakerList.push(value.AttendeeId);
        });

        if (hostList.indexOf(self.userid) > -1) {
          if (IsZoomRTMP) {
            self.rtmpActions(0, sessionID);
            //  self.GoForInternalPlayer(sessionID, externalLink);
          } else {
            window.open(ZoomDetails.start_url, "_blank");
            self.postLeaderboardAction("SNVW");
          }
        } else if (speakerList.indexOf(self.userid) > -1) {
          if (IsZoomRTMP) {
            self.rtmpActions(0, sessionID);
          } else {
            self.showLoader();

            let headers = {
              Authorization: "Bearer " + self.getSessionToken(),
              "content-type": "application/json",
            };
            let requestData = {
              email: self.email,
              name: self.name,
              first_name: self.firstName,
              last_name: self.lastName,
              webinarid: ZoomDetails.id,
              meeting_type: "webinar",
              make_speaker: true,
              //address: "",
              //phone: self.phone,
              //industry: "",
              //org: self.company,
              //job_title: self.title,
            };
            //bus.$emit("toggleLoader", true);
            axios
              .post(APIs.AddAttendeesToZoom, requestData, {
                headers: headers,
              })
              .then((response) => {
                if (
                  response &&
                  response.data &&
                  response.data.status == 0 &&
                  response.data.data.id &&
                  response.data.data.join_url &&
                  response.data.data.join_url != ""
                ) {
                  self.hideLoader();
                  debugger;
                  window.open(response.data.data.join_url, "_blank");
                  self.postLeaderboardAction("SNVW");

                  //let headers = {
                  //  "content-type": "application/json",
                  //};
                  //let requestData = {
                  //  email: self.email,
                  //  name: self.firstName + " " + self.lastName,
                  //  webinarid: ZoomDetails.id,
                  //};
                  //axios
                  //  .post(APIs.AddSpeakersToZoom, requestData, {
                  //    headers: headers,
                  //  })
                  //  .then((response1) => {
                  //    //debugger;
                  //    self.hideLoader();
                  //    if (response1.data && response1.data.id) {
                  //      window.open(response.data.join_url, "_blank");
                  //      self.postLeaderboardAction("SNVW");
                  //    } else {
                  //      self.retryJoinInZoomPopup();
                  //    }
                  //  })
                  //  .catch((error) => {
                  //    self.hideLoader();
                  //    console.log(error);
                  //    self.retryJoinInZoomPopup();
                  //  });
                } else {
                  self.hideLoader();
                  self.retryJoinInZoomPopup();
                }
              })
              .catch((error) => {
                self.hideLoader();
                console.log(error);
                self.retryJoinInZoomPopup();
              });
          }
        } else {
          if (IsZoomRTMP) {
            self.GoForInternalPlayer(sessionID, externalLink);
            //self.rtmpActions(0, sessionID);
          } else {
            let headers = {
              Authorization: "Bearer " + self.getSessionToken(),
              "content-type": "application/json",
            };
            let requestData = {
              email: self.email,
              name: self.name,
              first_name: self.firstName,
              last_name: self.lastName,
              webinarid: ZoomDetails.id,
              meeting_type: "webinar",
              make_speaker: false,
              //address: "",
              //phone: self.phone,
              //industry: "",
              //org: self.company,
              //job_title: self.title,
            };
            axios
              .post(APIs.AddAttendeesToZoom, requestData, {
                headers: headers,
              })
              .then((response) => {
                debugger;
                if (
                  response &&
                  response.data &&
                  response.data.status == 0 &&
                  response.data.data.id &&
                  response.data.data.join_url &&
                  response.data.data.join_url != ""
                ) {
                  window.open(response.data.data.join_url, "_blank");
                  self.postLeaderboardAction("SNVW");
                } else {
                  self.retryJoinInZoomPopup();
                }
              })
              .catch((error) => {
                console.log(error);
                self.retryJoinInZoomPopup();
              });
          }
        }
      } else {
        $(".tooltip").tooltip("hide");
        $(".modal").modal("hide");
        var obj2 = JSON.parse(window.localStorage.getItem("my-app"));
        if (
          screen.width < 767 &&
          obj2.AgoraPlayerBrowserSupportInMobile == false
        ) {
          router.push("/screeninfo");
        } else if (
          screen.width >= 768 &&
          screen.width <= 1024 &&
          obj2.AgoraPlayerBrowserSupportInIPad == false
        ) {
          router.push("/screeninfo");
        } else {
          self.GoForInternalPlayer(sessionID, externalLink);
        }
      }
    },
    getFormattedTime: function (seconds) {
      var dt = new Date(seconds * 1000);
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      minutes = minutes == 0 ? "00" : minutes;
      var formattedtime =
        hours.toString() + ":" + minutes.toString() + " " + amPM;
      return formattedtime;
    },
    getFormattedDateTime: function (seconds) {
      var dt = new Date(seconds * 1000);
      var day = dt.getDate();
      var month = dt.getMonth();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      minutes = minutes == 0 ? "00" : minutes;
      var formattedtime =
        hours.toString() + ":" + minutes.toString() + " " + amPM;
      formattedtime = monthNamesShort[month] + " " + day + ", " + formattedtime;
      return formattedtime;
    },
    Returndatetimeformat: function (seconds) {
      var dtt = "";
      dtt = new Date(seconds * 1000);
      var hours = dtt.getHours();
      var minutes =
        dtt.getMinutes().toString() == "0" ? "00" : dtt.getMinutes();
      var newformat = hours >= 12 ? "PM" : "AM";
      hours = hours >= 12 ? hours - 12 : hours;
      //var newformat = hours >= 12 ? "PM" : "AM";
      var formattedtime =
        hours.toString() + ":" + minutes.toString() + " " + newformat;
      return formattedtime;
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    hideModal: function () {
      this.$refs["my-modal"].hide();
    },
    toggleModal: function () {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["my-modal"].toggle("#toggle-btn");
    },
    ShowBroadCastPg: function (
      SessionId,
      openInNewTab,
      type,
      EventID,
      IsOpenInternalPlayer
    ) {
      console.log(openInNewTab);
      console.log(IsOpenInternalPlayer);
      $(".tooltip").tooltip("hide");
      $(".modal").modal("hide");
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      console.log(type);
      console.log(EventID);

      if (
        screen.width < 767 &&
        obj.AgoraPlayerBrowserSupportInMobile == false
      ) {
        router.push("/screeninfo");
      } else if (
        screen.width >= 768 &&
        screen.width <= 1024 &&
        obj.AgoraPlayerBrowserSupportInIPad == false
      ) {
        router.push("/screeninfo");
      } else {
        self.GoForInternalPlayer(SessionId, "");
      }
    },
    //18.06.2020 popup

    minimizeModal: function () {
      $("#modalOpenBroadcast").toggleClass("minimize");
      $("#modalOpenBroadcast").removeClass("maximize-window");
      $("#modalOpenBroadcast").removeClass("maximize-window");
      $("body").removeClass("modal-open");
      $(".modal-backdrop").hide();
    },
    MaximizeModal: function () {
      $("#modalOpenBroadcast").toggleClass("maximize-window");
      $("#modalOpenBroadcast").removeClass("minimize");
      $(".modal-backdrop").show();
    },
    showLoader: function () {
      //this.loaderFlg = true;
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },
    hideLoader: function () {
      clearTimeout(self.timerLoader);
      self.loaderFlg = false;

      if ($("#divLoading") != null) {
        $("#divLoading").hide();
      }
    },
    readCookieForVideo: function (name) {
      var nameEQ = encodeURIComponent(name) + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
          return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
      return null;
    },
    //getInitials: function (str) {
    //  var matches = str.match(/\b(\w)/g);
    //  var result = matches.join("");
    //  if (result.length > 2) {
    //    result = result.substring(0, 2);
    //  }
    //  return result;
    //},
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              analytics.AddUserAction(
                self.eventcollection,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                self.firstName + " " + self.lastName,
                self.email
              );
            }
          }
        } else {
          analytics.AddUserAction(
            self.eventcollection,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            self.firstName + " " + self.lastName,
            self.email
          );
        }
      }
    },
    onClickHandler(event) {
      //this.rtmpDialog.state = true;
      // event.target is the clicked element object
      self.AddAnalitics(event, "click");
      if (self.IsZoomRTMPOptionsEnabled) {
        self.toggleMoreSessionActions("");
        //event.stopPropagation();
      }
    },
    scroll: function () {
      window.onscroll = () => {
        if (!self.IsSearchMode) {
          let bottomOfWindow =
            document.documentElement.scrollTop + window.innerHeight + 1 >=
            document.documentElement.offsetHeight;
          if (bottomOfWindow) {
            //this.AddAnalitics(event, "scroll");
          }
        }
      };
    },
  },
};
</script>
<style scoped>
.page-head {
  font-size: 24px !important;
  font-weight: 700 !important;
}

/* .session-list-wrapper .nav-tabs .nav-item.show .nav-link, .session-list-wrapper .nav-tabs .nav-link.active{
    content: "" !important;
    position: absolute !important;
    height: 4px !important;
    width: 40px !important;
    background: #d0006f !important;
    bottom: 0 !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
} */

/* .nav {
    display: flex !important;
    flex-wrap: wrap !important;
    padding-left: 0 !important;
    margin-bottom: 0 !important;
    list-style: none !important;
}
.nav-tabs .nav-item {
    margin-bottom: -1px !important;
}
.session-list-wrapper .nav-tabs .nav-link {
    color: #696969 !important;
}
.session-list-wrapper .nav-tabs .nav-link {
    border: 0 !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    border-bottom: 4px solid transparent !important;
    background-color: transparent !important;
    transition: border-color .2s ease !important;
    color: #242432 !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
}
.nav-link {
    display: block !important;
    padding: .5rem 1rem !important;
}
 .active:after {
    content: "" !important;
    position: absolute !important;
    height: 4px !important;
    width: 40px !important;
    background: #d0006f !important;
    bottom: 0 !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
}
.session-list-wrapper .nav-tabs .nav-link {
    border: 0 !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    border-bottom: 4px solid transparent !important;
    background-color: transparent !important;
    transition: border-color .2s ease !important;
    color: #242432 !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
} */
</style>
